/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _fsVideo = __webpack_require__(32);
	
	var _fsVideo2 = _interopRequireDefault(_fsVideo);
	
	var _FsVideoWcEndcard = __webpack_require__(44);
	
	var _FsVideoWcEndcard2 = _interopRequireDefault(_FsVideoWcEndcard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_FsVideoWcEndcard2.default.initEndcards();
	
	var fsVideo = new _fsVideo2.default();
	fsVideo.initializeFSEmbedPlayer();

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.isObjectEmpty = exports.convertSecondsToTime = exports.getProfileData = exports.getSessionCampaignTraits = exports.setCampaignTraitsSession = exports.getPageMeta = undefined;
	
	var _urlSearchParams = __webpack_require__(5);
	
	var _urlSearchParams2 = _interopRequireDefault(_urlSearchParams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * get meta object from meta tag fs-prop="analytics" on the main article (first article on the 3things)
	 * @returns {object} Meta Object
	 */
	var getPageMeta = exports.getPageMeta = function getPageMeta() {
		var data = {};
		var metaEl = document.querySelector('[fs-prop="analytics"]');
		if (!metaEl) return data;
		var atts = metaEl.attributes;
		for (var i = 0, len = atts.length; i < len; i++) {
			if (atts[i].value != null) {
				var att = atts[i].name;
				var val = atts[i].value;
	
				att = att.indexOf('-') >= 0 ? att.replace(/-/g, '_') : att;
				data[att] = val.trim();
			}
		}
	
		return data;
	};
	
	// query string helpers
	var setCampaignTraitsSession = exports.setCampaignTraitsSession = function setCampaignTraitsSession() {
		if (window.location.search.length == 0) return;
	
		var queryStr = window.location.search;
		var campaignTraits = {
			"org": "campaign_organization",
			"ag": "campaign_agency",
			"mc": "campaign_type",
			"src": "campaign_source",
			"cmp": "campaign_name",
			"add": "campaign_additional",
			"cmpid": "campaign_tracking_code"
		};
		var query = new _urlSearchParams2.default(queryStr);
		var params = Object.keys(campaignTraits);
		var result = void 0;
	
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;
	
		try {
			for (var _iterator = query.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var key = _step.value;
	
				if (params.includes(key)) {
					if (!result) result = {};
	
					result[campaignTraits[key]] = query.get(key);
				}
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	
		if (result) {
			window.sessionStorage.setItem('sessionCampaignTraits', JSON.stringify(result));
		}
	
		return result;
	};
	
	var getSessionCampaignTraits = exports.getSessionCampaignTraits = function getSessionCampaignTraits() {
		var result = void 0;
	
		try {
			result = JSON.parse(window.sessionStorage.getItem('sessionCampaignTraits'));
			if (!result) {
				result = setCampaignTraitsSession();
			}
		} catch (e) {
			return;
		}
	
		return result;
	};
	
	/*
	`lastAnonymousProfileId`
	 + populate when user hasn't logged in
	 + pass blank on tracking when user is logged in
	 + pass last anon id if user is logged out (?)
	
	`lastKnownProfileId`
	 + pass blank when user hasn't logged in
	 + populate when user logs out
	 + pass blank when user logs back in (?)
	*/
	var getProfileData = exports.getProfileData = function getProfileData(objData) {
		if (window.wisRegistration) {
			var wisReg = window.wisRegistration;
			var isLoggedIn = wisReg.isUserLoggedIn();
			if (isLoggedIn) {
				var profileId = wisReg.getProfileId();
	
				objData.dcg_profile_id = profileId != null && !isObjectEmpty(profileId) ? profileId : null;
				if (objData.dcg_profile_id != null) sessionStorage.setItem('lastKnownProfileId', profileId);
			}
			objData.lastKnownProfileId = sessionStorage.getItem('lastKnownProfileId');
			objData.lastAnonymousProfileId = wisReg.getAnonProfileId() || sessionStorage.getItem('lastAnonymousProfileId');
	
			sessionStorage.setItem('lastAnonymousProfileId', objData.lastAnonymousProfileId);
		}
		return objData;
	};
	
	var convertSecondsToTime = exports.convertSecondsToTime = function convertSecondsToTime(secs) {
		var sec_num = parseInt(secs, 10);
		var hours = Math.floor(sec_num / 3600) % 24;
		var minutes = Math.floor(sec_num / 60) % 60;
		var seconds = sec_num % 60;
		var timeArr = hours > 0 ? [hours, minutes, seconds] : [minutes, seconds];
	
		return timeArr.map(function (v, i) {
			return !v < 10 ? i != 0 ? "0" + v : v : v;
		}).filter(function (v, i) {
			return v !== "00" || i > 0;
		}).join(":");
	};
	
	var isObjectEmpty = exports.isObjectEmpty = function isObjectEmpty(obj) {
		for (var key in obj) {
			if (obj.hasOwnProperty(key)) return false;
		}
		return true;
	};

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	Copyright (C) 2015-2017 Andrea Giammarchi - @WebReflection
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	
	*/
	'use strict';
	
	function URLSearchParams(query) {
	  var
	    index, key, value,
	    pairs, i, length,
	    dict = Object.create(null)
	  ;
	  this[secret] = dict;
	  if (!query) return;
	  if (typeof query === 'string') {
	    if (query.charAt(0) === '?') {
	      query = query.slice(1);
	    }
	    for (
	      pairs = query.split('&'),
	      i = 0,
	      length = pairs.length; i < length; i++
	    ) {
	      value = pairs[i];
	      index = value.indexOf('=');
	      if (-1 < index) {
	        appendTo(
	          dict,
	          decode(value.slice(0, index)),
	          decode(value.slice(index + 1))
	        );
	      } else if (value.length){
	        appendTo(
	          dict,
	          decode(value),
	          ''
	        );
	      }
	    }
	  } else {
	    if (isArray(query)) {
	      for (
	        i = 0,
	        length = query.length; i < length; i++
	      ) {
	        value = query[i];
	        appendTo(dict, value[0], value[1]);
	      }
	    } else if (query.forEach) {
	      query.forEach(addEach, dict);
	    } else {
	      for (key in query) {
	         appendTo(dict, key, query[key]);
	      }
	    }
	  }
	}
	
	var
	  isArray = Array.isArray,
	  URLSearchParamsProto = URLSearchParams.prototype,
	  find = /[!'\(\)~]|%20|%00/g,
	  plus = /\+/g,
	  replace = {
	    '!': '%21',
	    "'": '%27',
	    '(': '%28',
	    ')': '%29',
	    '~': '%7E',
	    '%20': '+',
	    '%00': '\x00'
	  },
	  replacer = function (match) {
	    return replace[match];
	  },
	  secret = '__URLSearchParams__:' + Math.random()
	;
	
	function addEach(value, key) {
	  /* jshint validthis:true */
	  appendTo(this, key, value);
	}
	
	function appendTo(dict, name, value) {
	  var res = isArray(value) ? value.join(',') : value;
	  if (name in dict)
	    dict[name].push(res);
	  else
	    dict[name] = [res];
	}
	
	function decode(str) {
	  return decodeURIComponent(str.replace(plus, ' '));
	}
	
	function encode(str) {
	  return encodeURIComponent(str).replace(find, replacer);
	}
	
	URLSearchParamsProto.append = function append(name, value) {
	  appendTo(this[secret], name, value);
	};
	
	URLSearchParamsProto.delete = function del(name) {
	  delete this[secret][name];
	};
	
	URLSearchParamsProto.get = function get(name) {
	  var dict = this[secret];
	  return name in dict ? dict[name][0] : null;
	};
	
	URLSearchParamsProto.getAll = function getAll(name) {
	  var dict = this[secret];
	  return name in dict ? dict[name].slice(0) : [];
	};
	
	URLSearchParamsProto.has = function has(name) {
	  return name in this[secret];
	};
	
	URLSearchParamsProto.set = function set(name, value) {
	  this[secret][name] = ['' + value];
	};
	
	URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
	  var dict = this[secret];
	  Object.getOwnPropertyNames(dict).forEach(function(name) {
	    dict[name].forEach(function(value) {
	      callback.call(thisArg, value, name, this);
	    }, this);
	  }, this);
	};
	
	/*
	URLSearchParamsProto.toBody = function() {
	  return new Blob(
	    [this.toString()],
	    {type: 'application/x-www-form-urlencoded'}
	  );
	};
	*/
	
	URLSearchParamsProto.toJSON = function toJSON() {
	  return {};
	};
	
	URLSearchParamsProto.toString = function toString() {
	  var dict = this[secret], query = [], i, key, name, value;
	  for (key in dict) {
	    name = encode(key);
	    for (
	      i = 0,
	      value = dict[key];
	      i < value.length; i++
	    ) {
	      query.push(name + '=' + encode(value[i]));
	    }
	  }
	  return query.join('&');
	};
	
	URLSearchParams = (module.exports = global.URLSearchParams || URLSearchParams);
	
	(function (URLSearchParamsProto) {
	
	  var iterable = (function () {
	    try {
	      return !!Symbol.iterator;
	    } catch(error) {
	      return false;
	    }
	  }());
	
	  // mostly related to issue #24
	  if (!('forEach' in URLSearchParamsProto)) {
	    URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
	      var names = Object.create(null);
	      this.toString()
	          .replace(/=[\s\S]*?(?:&|$)/g, '=')
	          .split('=')
	          .forEach(function (name) {
	            if (!name.length || name in names) return;
	            (names[name] = this.getAll(name)).forEach(function(value) {
	              callback.call(thisArg, value, name, this);
	            }, this);
	          }, this);
	    };
	  }
	
	  if (!('keys' in URLSearchParamsProto)) {
	    URLSearchParamsProto.keys = function keys() {
	      var items = [];
	      this.forEach(function(value, name) { items.push(name); });
	      var iterator = {
	        next: function() {
	          var value = items.shift();
	          return {done: value === undefined, value: value};
	        }
	      };
	
	      if (iterable) {
	        iterator[Symbol.iterator] = function() {
	          return iterator;
	        };
	      }
	
	      return iterator;
	    };
	  }
	
	  if (!('values' in URLSearchParamsProto)) {
	    URLSearchParamsProto.values = function values() {
	      var items = [];
	      this.forEach(function(value) { items.push(value); });
	      var iterator = {
	        next: function() {
	          var value = items.shift();
	          return {done: value === undefined, value: value};
	        }
	      };
	
	      if (iterable) {
	        iterator[Symbol.iterator] = function() {
	          return iterator;
	        };
	      }
	
	      return iterator;
	    };
	  }
	
	  if (!('entries' in URLSearchParamsProto)) {
	    URLSearchParamsProto.entries = function entries() {
	      var items = [];
	      this.forEach(function(value, name) { items.push([name, value]); });
	      var iterator = {
	        next: function() {
	          var value = items.shift();
	          return {done: value === undefined, value: value};
	        }
	      };
	
	      if (iterable) {
	        iterator[Symbol.iterator] = function() {
	          return iterator;
	        };
	      }
	
	      return iterator;
	    };
	  }
	
	  if (iterable && !(Symbol.iterator in URLSearchParamsProto)) {
	    URLSearchParamsProto[Symbol.iterator] = URLSearchParamsProto.entries;
	  }
	
	  if (!('sort' in URLSearchParamsProto)) {
	    URLSearchParamsProto.sort = function sort() {
	      var
	        entries = this.entries(),
	        entry = entries.next(),
	        done = entry.done,
	        keys = [],
	        values = Object.create(null),
	        i, key, value
	      ;
	      while (!done) {
	        value = entry.value;
	        key = value[0];
	        keys.push(key);
	        if (!(key in values)) {
	          values[key] = [];
	        }
	        values[key].push(value[1]);
	        entry = entries.next();
	        done = entry.done;
	      }
	      // not the champion in efficiency
	      // but these two bits just do the job
	      keys.sort();
	      for (i = 0; i < keys.length; i++) {
	        this.delete(keys[i]);
	      }
	      for (i = 0; i < keys.length; i++) {
	        key = keys[i];
	        this.append(key, values[key].shift());
	      }
	    };
	  }
	
	}(URLSearchParams.prototype));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Viewports = function () {
	    function Viewports() {
	        var _this = this;
	
	        var viewports = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { 'mobile': 767, 'tablet': 768, 'desktop': 1024 };
	
	        _classCallCheck(this, Viewports);
	
	        var userAgent = window.navigator.userAgent;
	
	        this.winW = window.innerWidth;
	        this.winH = window.innerHeight;
	        this.docW = document.body.clientWidth;
	        this.isIOSSafari = userAgent.match(/iPhone|iPod|iPad/i) && userAgent.match(/Safari/i) && userAgent.match(/Chrome|CriOS/i) === null;
	        this.isIOS = userAgent.match(/iPhone|iPod|iPad/i);
	        this.isIphone = userAgent.match(/iPhone/i);
	        this.isAndroid = userAgent.match(/Android/i);
	        this.isIPad = userAgent.match(/iPad/i);
	        this.isMobile = userAgent.match(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i);
	        this.isTouch = userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
	        this.viewPorts = viewports;
	
	        window.addEventListener("resize", function () {
	            _this.setWinW(window.innerWidth);
	            _this.setWinH(window.innerHeight);
	            _this.setDocW(document.body.clientWidth);
	        });
	    }
	
	    //setter for window inner width
	
	
	    _createClass(Viewports, [{
	        key: 'setWinW',
	        value: function setWinW(w) {
	            this.winW = w;
	        }
	
	        //getter for window inner width
	
	    }, {
	        key: 'getWinW',
	        value: function getWinW() {
	            return this.winW;
	        }
	
	        //setter for document body clientWidth
	
	    }, {
	        key: 'setDocW',
	        value: function setDocW(w) {
	            this.docW = w;
	        }
	
	        //getter for document body clientWidth
	
	    }, {
	        key: 'getDocW',
	        value: function getDocW() {
	            return this.docW;
	        }
	
	        //setter for winH
	
	    }, {
	        key: 'setWinH',
	        value: function setWinH(h) {
	            this.winH = h;
	        }
	
	        //getter for winH
	
	    }, {
	        key: 'getWinH',
	        value: function getWinH() {
	            return this.winH;
	        }
	    }, {
	        key: 'getViewPort',
	        value: function getViewPort() {
	            var winW = this.winW;
	            return winW <= this.viewPorts.mobile ? 'mobile' : winW >= this.viewPorts.desktop ? 'desktop' : 'tablet';
	        }
	
	        /**
	         * @desc checking element is in view. This function works well to determine if the element is in view,
	         * but it takes a little time to do the calculation to get top, bottom, left and right positions
	         * @param object el
	         * @return bool - true or false
	         */
	
	    }, {
	        key: 'isElmInViewport',
	        value: function isElmInViewport(el) {
	
	            var rect = el.getBoundingClientRect();
	
	            return rect && rect.top >= 0 && rect.left >= 0 && rect.bottom <= this.winH && rect.right <= this.winW;
	        }
	
	        /**
	         * @desc checking element top postion is passing . This function works faster than the above isElmInViewport ,
	         * since we only need to check elment top position. This should be good to use if we just want to check the scroll
	         * position and doing pinning or lazyloading the scripts
	         * @param dom object el
	         * @param Number offet: passing an offet here if we want the scroll event rendered a bit early
	         * @return bool - true or false
	         */
	
	    }, {
	        key: 'isElmTopPosPassing',
	        value: function isElmTopPosPassing(el, offet) {
	
	            var rect = el.getBoundingClientRect();
	            var checkPos = undefined;
	
	            if (offet !== undefined && !isNaN(offet)) {
	                checkPos = rect.top - offet;
	            } else {
	                checkPos = rect.top;
	            }
	
	            return checkPos <= this.winH;
	        }
	    }]);
	
	    return Viewports;
	}();
	
	exports.default = Viewports;

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SegmentAnalytics = function () {
		function SegmentAnalytics(props) {
			_classCallCheck(this, SegmentAnalytics);
	
			this.metaEl = document.querySelector('[fs-prop="analytics"]') != null ? (0, _utils.getPageMeta)() : null;
			this.defaultSpaReferrer = window.location.href;
			this.segmentApiKey = null;
	
			// tracking functions
			this.trackPage = this.trackPage.bind(this);
			this.trackEvent = this.trackEvent.bind(this);
			this.trackVideoEvent = this.trackVideoEvent.bind(this);
			this.setSegmentLoaded = this.setSegmentLoaded.bind(this);
			this.initScript = this.initScript.bind(this);
	
			// data retrieval functions
			this.sportsTypes = this.getSportsTypes();
			this.duration = 0;
			this.secondsViewed = 0;
			this.last_video_length = 0;
			this.current_video_length = 0;
			this.total_length = 0;
			this.getDefaultProps = this.getDefaultProps.bind(this);
			this.getPageProps = this.getPageProps.bind(this);
			this.getEventProps = this.getEventProps.bind(this);
			this.getCategory = this.getCategory.bind(this);
			this.getContentName = this.getContentName.bind(this);
			this.getLandingName = this.getLandingName.bind(this);
			this.getPageName = this.getPageName.bind(this);
			this.getPageType = this.getPageType.bind(this);
			this.getSubCategory = this.getSubCategory.bind(this);
			this.getPageSubType = this.getPageSubType.bind(this);
			this.getStoryTitle = this.getStoryTitle.bind(this);
			this.getPageContentLevels = this.getPageContentLevels.bind(this);
			this.getDuration = this.getDuration.bind(this);
			this.setSecondsViewed = this.setSecondsViewed.bind(this);
			this.getSecondsViewed = this.getSecondsViewed.bind(this);
		}
	
		_createClass(SegmentAnalytics, [{
			key: 'getSportsTypes',
			value: function getSportsTypes() {
				return ['mlb', 'nfl', 'nascar', 'college-football', 'college-basketball', 'soccer', 'ufc', 'golf', 'nhl', 'nba', 'tennis', 'boxing', 'olympics', 'motor', 'horse-racing', 'other', 'baseball', 'basketball', 'bowling', 'cricket', 'cycling', 'football', 'gymnastics', 'hockey', 'mma', 'rugby', 'skiing', 'swimming', 'volleyball', 'water-polo', 'wnba', 'womens-college-basketball', 'wrestling', 'wwe'];
			}
		}, {
			key: 'getCategory',
			value: function getCategory() {
				return this.metaEl['category'];
			}
		}, {
			key: 'getSubCategory',
			value: function getSubCategory() {
				return this.metaEl['sub_category'];
			}
		}, {
			key: 'getLandingName',
			value: function getLandingName() {
				var name = this.metaEl['landing_name'];
				if (name) name = name.replace(/\s\s+/g, ' ');
				// CHECK: if page has hash string
				if (window.location.hash) {
					var hash = window.location.hash;
					if (hash.indexOf('nav-option') > -1) {
						name = name.replace('Landing', 'Category');
					}
				}
				return name;
			}
		}, {
			key: 'getPageName',
			value: function getPageName() {
				var pageName = this.metaEl ? this.metaEl['seg_page_name'] : "no page name";
				if (pageName) return pageName.replace('::', ':');
			}
		}, {
			key: 'getPageSubType',
			value: function getPageSubType() {
				return this.metaEl ? this.metaEl['page_sub_type'] : "no page sub type";
			}
		}, {
			key: 'getContentName',
			value: function getContentName() {
				return this.metaEl ? this.metaEl['content_name'] : "no content name";
			}
		}, {
			key: 'getStoryTitle',
			value: function getStoryTitle() {
				return this.metaEl ? this.metaEl['story_title'] : "no story title";
			}
		}, {
			key: 'getBuildVersion',
			value: function getBuildVersion() {
				return this.metaEl ? this.metaEl['build_version'] : "no build version";
			}
		}, {
			key: 'getPageType',
			value: function getPageType() {
	
				var pageType = this.metaEl ? this.metaEl['page_type'] : "no page type";
	
				if (pageType === 'home') return 'section front';
	
				return pageType;
			}
		}, {
			key: 'getPageContentLevels',
			value: function getPageContentLevels(props) {
				if (this.metaEl) {
					if (this.metaEl.page_content_level_1) props.properties.page_content_level_1 = this.metaEl.page_content_level_1.replace('::', ':');
					if (this.metaEl.page_content_level_2) props.properties.page_content_level_2 = this.metaEl.page_content_level_2.replace('::', ':');
					if (this.metaEl.page_content_level_3) props.properties.page_content_level_3 = this.metaEl.page_content_level_3.replace('::', ':');
					if (this.metaEl.page_content_level_4) props.properties.page_content_level_4 = this.metaEl.page_content_level_4.replace('::', ':');
				} else {
					props.properties.page_content_level_1 = "no content level 1";
					props.properties.page_content_level_2 = "no content level 2";
					props.properties.page_content_level_3 = "no content level 3";
					props.properties.page_content_level_4 = "no content level 4";
				}
	
				return props;
			}
		}, {
			key: 'getPosition',
			value: function getPosition(position) {
				var adTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
				return parseInt(position - adTime, 10);
			}
		}, {
			key: 'getDuration',
			value: function getDuration(duration) {
				if (duration) {
					duration = parseInt(duration, 10);
					if (duration > 0 && duration != this.duration) this.duration = duration;
				}
				return this.duration;
			}
		}, {
			key: 'setSecondsViewed',
			value: function setSecondsViewed(secondsViewed) {
				if (secondsViewed && secondsViewed > 0) this.secondsViewed = secondsViewed;
			}
		}, {
			key: 'getSecondsViewed',
			value: function getSecondsViewed(eventName) {
				if (eventName.indexOf('Playing') > -1) return 10;
				return Math.floor(this.secondsViewed % 10);
			}
		}, {
			key: 'setCampaignTraits',
			value: function setCampaignTraits(props) {
				var campaignTraits = (0, _utils.getSessionCampaignTraits)();
	
				if (campaignTraits) {
					for (var trait in campaignTraits) {
						props.properties[trait] = campaignTraits[trait];
					}
				}
	
				return props;
			}
		}, {
			key: 'getDefaultProps',
			value: function getDefaultProps(type, eventName) {
				var traits = {
					dcg_profile_id: null,
					appsflyer_id: 'no appsflyer id',
					network_entitlements_list: 'no entitlements',
					lastKnownProfileId: null,
					lastAnonymousProfileId: null,
					mvpd: 'no mvpd'
				};
				var defaultProps = {
					primary_business_unit: 'fng',
					secondary_business_unit: 'fox sports',
					app_name: 'foxsports.com',
					app_platform: 'web',
					app_version: 'no app version',
					app_build: 'no build version',
					referrer: this.defaultSpaReferrer,
					page_test_name: 'no test name',
					page_timePartingDay: 'no time parting day',
					page_timePartingHour: 'no time parting hour',
					campaign_tracking_code: 'no tracking code',
					campaign_organization: 'no organization',
					campaign_marketing_channel: 'no marketing channel',
					campaign_source: 'no source',
					campaign_name: 'no name',
					campaign_additional: 'no additional',
					campaign_agency: 'no agency',
					page_name: 'no page name',
					page_type: 'no page type',
					page_content_level_1: 'no content level 1',
					page_content_level_2: 'no content level 2',
					page_content_level_3: 'no content level 3',
					page_content_level_4: 'no content level 4',
					favorites_length: 'no favorites',
					favorites_list: 'no favorites',
					favorites_sports_length: 'no favorite sports',
					favorites_sports_list: 'no favorite sports',
					favorites_teams_length: 'no favorite teams',
					favorites_teams_list: 'no favorite teams',
					rivals_sports_length: 'no rival sports',
					rivals_sports_list: 'no rival sports',
					rivals_teams_length: 'no rival teams',
					rivals_teams_list: 'no rival teams',
					subscriptions_length: 'no subscriptions',
					subscriptions_list: 'no subscriptions',
					push_enabled: 'no push'
				};
	
				var props = void 0;
	
				// for page view
				if (type === 'page') {
					props = Object.assign(defaultProps, {
						keywords: 'no keywords',
						page_content_author: 'no author',
						page_content_original_publish_date: 'no content original publish date',
						page_content_major_publish_date: 'no content major publish date',
						page_content_modified_date: 'no content modified date',
						page_content_original_publish_time: 'no content original publish time',
						page_content_major_publish_time: 'no content major publish time',
						page_content_modified_time: 'no content modified time',
						page_content_version: 'no content version',
						page_content_title: 'no content title',
						page_content_id: 'no content id',
						page_content_type: 'no content type',
						page_content_type_of_story: 'no story type',
						page_content_tags: 'no content tags',
						page_content_category: 'no content category',
						page_content_subcategory: 'no content subcategory',
						page_content_language: 'no content language',
						page_login_state: 'no login state',
						page_content_originator: 'no content originator'
					});
					return {
						name: 'no page name',
						context: { traits: traits },
						properties: props
					};
				}
				// for event
				if (type === 'video' && eventName) {
					// for video events
					props = Object.assign(defaultProps, this.getVideoEventDefaultProps(eventName));
				} else {
					// for custom/other events
					props = defaultProps;
				}
	
				return {
					event: eventName || 'no event name',
					context: { traits: traits },
					properties: props
				};
			}
		}, {
			key: 'getVideoEventDefaultProps',
			value: function getVideoEventDefaultProps(eventName) {
				// main default props for video events
				var props = {
					session_id: 'no session id',
					position: 0,
					total_length: 'no total length',
					video_player_state: 'no player state',
					video_player_content_type: 'no player content type',
					video_asset_title: 'no asset title',
					video_asset_id: 'no asset id',
					video_channel_group_id: 'no channel group id',
					video_primary_business_unit: 'fng',
					video_secondary_business_unit: 'fox sports',
					video_series_id: 'no series id',
					video_series_name: 'no series name',
					video_fox_profile: false,
					video_content_length: 86400,
					video_content_type: 'no content type',
					video_ad_supported: false,
					video_ad_model: 'no ad model',
					video_content_length_format: 'no format',
					video_rating: 'no rating',
					video_asset_category: 'no asset category',
					video_genre: 'no genre',
					video_season_number: 'no season',
					video_episode_number: 'no episode',
					video_tms_id: 'no tms id',
					video_station_id: 'no station id',
					video_network: 'no network',
					video_affiliate_window: 'no affiliate window',
					video_authorizing_network: 'no authorizing network',
					video_player_type: 'standard player',
					video_content_channel: 'no content channel',
					video_ugc_clip: 'none',
					video_sports_type: 'no sport',
					video_sponsor: 'no sponsor',
					video_screen_layout: 'no multiview',
					video_airplay: false,
					video_first_air_date: 'no nfirst air date',
					video_first_digital_date: 'no first digital date',
					video_originator: 'no source',
					video_cross_device_play: false,
					video_cast_source_name: 'no case source name',
					video_cast_source_platform: 'no cast source platform',
					video_cast_source_version: 'no cast source version',
					video_cast_source_build: 'no cast source build',
					video_content_subscription_type: 'no content subscription type',
					video_feed: 'no feed',
					video_is_resume: false,
					video_is_continuous: false,
					video_is_restart: false,
					video_is_autoplay: false,
					video_is_fullscreen: false,
					video_is_livestream: false,
					video_volume: 'no volume'
				};
				// other props, segregated to subtypes (playback, content, ad)
				var subtypesProps = {
					playback: {
						bitrate: 'no bitrate',
						framerate: 'no framerate',
						livestream: false,
						ad_type: 'no ad type',
						content_pod_id: 'no content pod id',
						ad_asset_id: 'no ad asset id',
						ad_pod_id: 'no ad pod id',
						video_player: 'no video player',
						sound: 'no sound',
						full_screen: false,
						ad_enabled: true,
						quality: 'no quality'
					},
					content: {
						bitrate: 'no bitrate',
						framerate: 'no framerate',
						livestream: false,
						asset_id: 'no asset id',
						pod_id: 'no pod id',
						title: 'no title',
						publisher: 'no publisher',
						description: 'no description',
						keywords: 'no keywords',
						season: 'no season',
						episode: 'no episode',
						genre: 'no genre',
						program: 'no program',
						channel: 'no channel',
						full_episode: false,
						airdate: 'no airdate'
					},
					ad: {
						asset_id: 'no asset id',
						pod_id: 'no pod id',
						title: 'no title',
						publisher: 'no publisher',
						content: null,
						pod_position: 'no pod position',
						pod_length: 'no pod length',
						type: 'no type',
						load_type: 'no load type',
						video_ad_name: 'no ad name',
						video_ad_length: 'no ad length',
						video_ad_id: 'no ad id',
						video_fw_vcid2: 'no vcid2',
						video_fw_sitesection: 'no site section',
						video_ad_break_type: 'no ad break type',
						video_ad_break_name: 'no ad break name',
						video_ad_break_position: 'no ad break position',
						video_ad_pod_id: 'no ad pod id',
						video_ad_pod_type: 'no ad pod type',
						video_ad_pod_name: 'no ad pod name',
						video_ad_pod_position: 'no ad pod position',
						video_ad_in_pod_position: 'no ad in pod position',
						video_ad_campaign_id: 'no ad campaign id',
						video_ad_creative_id: 'no ad creative id',
						video_ad_site_id: 'no ad site id',
						video_ad_placement_id: 'no ad placement id',
						video_ad_advertiser: 'no advertiser name',
						video_ad_creative_url: 'no ad creative url'
					}
				};
	
				switch (eventName) {
					case 'Video Playback Seek Started':
						props = Object.assign(props, { seek_position: 'no seek position' });
						break;
					case 'Video Playback Started':
						props = Object.assign(props, {
							content_asset_ids: 'no content asset ids',
							content_pod_ids: 'no content pod ids'
						});
						break;
					case 'Video Playback Interrupted':
						props = Object.assign(props, { method: 'no method' });
						break;
					case 'Video Ad Playing':
						props = Object.assign(props, {
							video_seconds_viewed: 0,
							quartile: null
						});
						break;
					case 'Video Content Playing':
					case 'Video Content Completed':
					case 'Video Ad Completed':
						props = Object.assign(props, { video_seconds_viewed: 0 });
						break;
					default:
						break;
				}
				var subtype = this.getVideoSubType(eventName);
	
				if (subtype) props = Object.assign(props, subtypesProps[subtype]);
	
				return props;
			}
		}, {
			key: 'getSegmentEventName',
			value: function getSegmentEventName(eventName) {
				var eventsEnum = {
					'OnPlaybackStart': 'Video Playback Started',
					'OnPlaybackComplete': 'Video Playback Completed',
					'OnContentStart': 'Video Content Started',
					'OnContentComplete': 'Video Content Completed',
					'OnContentPlaying': 'Video Content Playing'
					// TODO: delete once JW player is implemented 100%
					// TODO: un-comment video ads-related events once its ready for tracking
					// 'OnMediaPlay': 'Video Playback Started',
					// 'OnMediaPause': 'Video Playback Paused',
					// 'OnMediaUnpause': 'Video Playback Resumed',
					// 'OnMediaEnd': 'Video Playback Completed',
					// 'OnMediaBuffer': 'Video Playback Buffer Started',
					// 'OnMediaSeek': 'Video Playback Seek Started',
					// 'OnMediaPlaying': 'Video Content Playing',
					// 'OnMediaStart': 'Video Content Started',
					// 'OnMediaComplete': 'Video Content Completed',
					// 'onAdStart': 'Video Ad Started',
					// 'onAdComplete': 'Video Ad Completed',
					// 'onSeekStart': 'Video Playback Seek Started',
					// 'onSeekComplete': 'Video Playback Seek Completed',
					// videoLoad: 'OnLoadReleaseUrl',
					// videoError: 'OnMediaError',
					// videoLoading: 'OnMediaLoadStart',
					// videoReady: 'OnLoadRelease',
					// videoMute: 'OnMute',
					// playerReady: 'OnPlayerLoaded',
					// playerOverlayUp: 'OnShowPlayOverlay'	
					// playerFullScreen: 'OnShowFullScreen',
					// adPodStart: 'onAdPodStart',
					// adPodComplete: 'onAdPodComplete',
				};
	
				return eventsEnum[eventName] ? eventsEnum[eventName] : null;
			}
		}, {
			key: 'getVideoSubType',
			value: function getVideoSubType(eventName) {
				var subTypesEnum = {
					'Video Playback Started': 'playback',
					'Video Playback Paused': 'playback',
					'Video Playback Buffer Started': 'playback',
					'Video Playback Buffer Completed': 'playback',
					'Video Playback Resumed': 'playback',
					'Video Playback Completed': 'playback',
					'Video Playback Interrupted': 'playback',
					'Video Playback Seek Started': 'playback',
					'Video Playback Seek Completed': 'playback',
					'Video Content Started': 'content',
					'Video Content Playing': 'content',
					'Video Content Completed': 'content',
					'Video Ad Started': 'ad',
					'Video Ad Playing': 'ad',
					'Video Ad Completed': 'ad',
					'Video Ad Break Started': 'ad',
					'Video Ad Break Completed': 'ad',
					'Video Ad Paused': 'ad',
					'Video Ad Resumed': 'ad'
				};
	
				return subTypesEnum[eventName] ? subTypesEnum[eventName] : null;
			}
		}, {
			key: 'setGlobalProps',
			value: function setGlobalProps(props) {
				var pageName = this.getPageName();
				var pageType = this.getPageType();
				var storyTitle = this.getStoryTitle();
				var buildVersion = this.getBuildVersion();
	
				if (pageName) props.properties.page_name = pageName;
				if (pageType) props.properties.page_type = pageType;
				if (storyTitle) {
					props.properties.story_title = storyTitle;
					if (props.properties.title) props.properties.title = storyTitle;
					if (props.properties.program) props.properties.program = storyTitle;
				}
				if (buildVersion) props.properties.app_build = buildVersion;
	
				props.context.traits = (0, _utils.getProfileData)(props.context.traits);
	
				props = this.getPageContentLevels(props);
				props = this.setCampaignTraits(props);
	
				return props;
			}
		}, {
			key: 'getPageProps',
			value: function getPageProps(name, data) {
				var props = this.setGlobalProps(this.getDefaultProps('page'));
				props.name = name || this.getLandingName();
	
				if (data) {
					if (data.properties) {
						for (var prop in data.properties) {
							props.properties[prop] = data.properties[prop];
						}
					}
					if (data.context && data.context.traits) {
						for (var trait in data.context.traits) {
							props.context.traits[trait] = data.context.traits[trait];
						}
					}
				}
	
				return props;
			}
		}, {
			key: 'getEventProps',
			value: function getEventProps(eventName, data) {
				eventName = this.getSegmentEventName(eventName);
				var props = this.setGlobalProps(this.getDefaultProps('event', eventName));
	
				props.event = eventName;
	
				if (data) {
					if (data.properties) {
						for (var prop in data.properties) {
							props.properties[prop] = data.properties[prop];
						}
					}
					if (data.context && data.context.traits) {
						for (var trait in data.context.traits) {
							props.context.traits[trait] = data.context.traits[trait];
						}
					}
				}
	
				return props;
			}
		}, {
			key: 'getVideoEventProps',
			value: function getVideoEventProps(eventName, data) {
				var props = this.setGlobalProps(this.getDefaultProps('video', eventName));
	
				props.event = eventName;
	
				if (data.isJWPlayer) {
					props.properties.session_id = data.player.guid;
					props.properties.position = eventName.indexOf('Started') > -1 ? 0 : this.getPosition(data.player.playerGetPosition(), data.player.priorAdTime);
					this.current_video_length = this.getDuration(data.player.duration);
					if (this.current_video_length != this.last_video_length && data.player.contentType == 'main') {
						this.last_video_length = this.current_video_length;
						this.total_length += this.current_video_length;
					}
					if (this.total_length > 0) props.properties.total_length = this.total_length;
					if (data.player.options.mode) {
						props.properties.livestream = data.player.isLive;
						if (props.properties.livestream) {
							props.properties.video_content_type = 'LIVE';
						} else {
							props.properties.video_content_type = data.player.options.mode.toUpperCase();
						}
					}
					props.properties.video_fox_profile = props.context.traits.dcg_profile_id != null;
					props.properties.video_player_state = function (playerState) {
						if (playerState === 'Started') return 'start';
						if (playerState === 'Completed') return 'end';
						if (playerState === 'Playing') return 'play';
	
						return 'no player state';
					}(eventName.split(/[\s,]+/).pop());
					// conditional props
					if (props.properties.content_asset_ids && data.player.contentAssetId) props.properties.content_asset_ids = [data.player.contentAssetId];
					if (props.properties.video_asset_id && data.player.currentId) props.properties.video_asset_id = data.player.currentId;
					if (props.properties.asset_id && data.player.currentId) props.properties.asset_id = data.player.currentId;
					if (props.properties.video_player_content_type && data.player.contentType) props.properties.video_player_content_type = data.player.contentType;
					if (!data.player.isLive && this.current_video_length > 0) {
						props.properties.video_content_length = this.current_video_length;
					}
					if (props.properties.video_content_length_format) {
						props.properties.video_content_length_format = props.properties.video_content_type && props.properties.video_content_type === 'LIVE' ? 'long-form' : 'short-form';
					}
					if (props.properties.video_network && data.assetInfo.network) props.properties.video_network = data.assetInfo.network;
					if (props.properties.video_sports_type && this.sportsTypes.indexOf(data.mainVideoData.categoryName.toLowerCase()) > -1) props.properties.video_sports_type = data.mainVideoData.categoryName;
					if (typeof props.properties.video_seconds_viewed !== 'undefined') {
						props.properties.video_seconds_viewed = this.getSecondsViewed(eventName);
					}
				}
				return props;
			}
		}, {
			key: 'setSegmentLoaded',
			value: function setSegmentLoaded(flag) {
				return window.segmentLoaded = flag;
			}
		}, {
			key: 'check',
			value: function check() {
				return typeof window.segmentLoaded === 'undefined' ? false : window.segmentLoaded;
			}
		}, {
			key: 'trackPage',
			value: function trackPage(name, props) {
				var self = this;
				return new Promise(function (resolve, reject) {
					/* https://segment.com/docs/sources/website/analytics.js/#page */
	
					if (!self.check()) {
						try {
							self.initScript(self.segmentApiKey, false);
						} catch (e) {
							return reject('SEGMENT ANALYTICS !! - Segment Analytics is not initialized');
						}
					}
					var meta = props || self.metaEl;
					if (!meta) {
						return reject('SEGMENT ANALYTICS !! - analytics meta tag or props are required and are missing');
					}
	
					props = self.getPageProps(name, meta);
					name = name || props.name;
					/* NOTE: `trackPage` params takes priority over default/meta values from getPageProps */
					console.debug('Segment page tracking (' + name + '): ' + JSON.stringify(props));
					window.analytics.page(name, props.properties, { context: props.context });
	
					resolve();
				});
			}
		}, {
			key: 'trackVideoEvent',
			value: function trackVideoEvent(eventName, data) {
				var self = this;
				return new Promise(function (resolve, reject) {
					/* https://segment.com/docs/sources/website/analytics.js/#track */
					if (!self.check()) {
						try {
							self.initScript(self.segmentApiKey, false);
						} catch (e) {
							return reject('SEGMENT ANALYTICS !! - Segment Analytics is not initialized');
						}
					}
					if (!eventName) return reject('SEGMENT ANALYTICS !! - video event name is required');
					if (!data) return reject('SEGMENT ANALYTICS !! - video event data is required');
	
					eventName = self.getSegmentEventName(eventName);
	
					if (eventName == null) {
						return reject('SEGMENT ANALYTICS !! - event(' + eventName + ') is not recognized as a segment event.');
					}
	
					var props = self.getVideoEventProps(eventName, data);
					console.debug('Segment video event tracking (' + eventName + ') - ' + JSON.stringify(props));
					window.analytics.track(eventName, props.properties, { context: props.context });
					resolve();
				});
			}
		}, {
			key: 'trackEvent',
			value: function trackEvent(eventName, data) {
				var self = this;
				return new Promise(function (resolve, reject) {
					/* https://segment.com/docs/sources/website/analytics.js/#track */
					if (!self.check()) {
						try {
							self.initScript(self.segmentApiKey, false);
						} catch (e) {
							return reject('SEGMENT ANALYTICS !! - Segment Analytics is not initialized');
						}
					}
					if (!eventName) return reject('SEGMENT ANALYTICS !! - event name is required');
					if (!data) return reject('SEGMENT ANALYTICS !! - event data is required');
	
					var props = self.getEventProps(eventName, data);
					console.debug('Segment event tracking (' + eventName + ') - ' + JSON.stringify(props));
					window.analytics.track(eventName, props.properties, { context: props.context });
	
					resolve();
				});
			}
		}, {
			key: 'initScript',
			value: function initScript() {
				var segmentApiKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
				var enablePageLoadTracking = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
				var self = this;
	
				if (!self.check()) {
	
					self.segmentApiKey = function (key) {
						if (typeof key === 'string' && key.length > 0) return key;
						return self.metaEl != null && self.metaEl.hasOwnProperty('segment_api_key') && self.metaEl['segment_api_key'] ? self.metaEl['segment_api_key'] : null;
					}(segmentApiKey);
	
					!function () {
						var analytics = window.analytics = window.analytics || [];if (!analytics.initialize) if (analytics.invoked) window.console && console.error && console.error("Segment snippet included twice.");else {
							analytics.invoked = !0;analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group", "track", "ready", "alias", "debug", "page", "once", "off", "on"];analytics.factory = function (t) {
								return function () {
									var e = Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics;
								};
							};for (var t = 0; t < analytics.methods.length; t++) {
								var e = analytics.methods[t];analytics[e] = analytics.factory(e);
							}analytics.load = function (t) {
								var e = document.createElement("script");e.type = "text/javascript";e.async = !0;e.src = ("https:" === document.location.protocol ? "https://" : "http://") + "cdn.segment.com/analytics.js/v1/" + t + "/analytics.min.js";var n = document.getElementsByTagName("script")[0];n.parentNode.insertBefore(e, n);
							};analytics.SNIPPET_VERSION = "4.0.0";
							window.analytics.load(self.segmentApiKey);
							self.setSegmentLoaded(true);
	
							if (enablePageLoadTracking) {
								self.trackPage();
							}
						}
					}();
				}
			}
		}]);
	
		return SegmentAnalytics;
	}();
	
	window.SegmentAnalytics = new SegmentAnalytics();
	
	exports.default = window.SegmentAnalytics;

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Pinner2 = __webpack_require__(33);
	
	var _Pinner3 = _interopRequireDefault(_Pinner2);
	
	var _TrackingUtils = __webpack_require__(34);
	
	var _TrackingUtils2 = _interopRequireDefault(_TrackingUtils);
	
	var _FsVideoEventHandler = __webpack_require__(35);
	
	var _FsVideoEventHandler2 = _interopRequireDefault(_FsVideoEventHandler);
	
	var _Viewports = __webpack_require__(7);
	
	var _Viewports2 = _interopRequireDefault(_Viewports);
	
	var _fsPlayerUtils = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // FsVideo.js
	
	
	var FsVideo = function (_Pinner) {
	    _inherits(FsVideo, _Pinner);
	
	    function FsVideo() {
	        _classCallCheck(this, FsVideo);
	
	        var _this = _possibleConstructorReturn(this, (FsVideo.__proto__ || Object.getPrototypeOf(FsVideo)).call(this));
	
	        _this.collectionOneUtm = {
	            campaign: "video_playback_location",
	            medium: "video_player",
	            content: "",
	            source: "homepage",
	            term: ""
	        };
	        var trendingTitleEl = document.querySelector('#center-piece > .trending-title');
	        _this.urlQuery = location.search;
	        _this.isModalEnabled = document.body.classList.contains('video-modal');
	        _this.bodySection = document.querySelector('.body-content');
	        _this.isSectionFront = document.body.classList.contains('single-fox_sectionfront');
	        _this.isCollectionSF = !!document.querySelector('.collections-section-front');
	        _this.isMediaHub = document.body.classList.contains('single-fox_media_hub');
	        _this.isBB = _this.bodySection ? _this.bodySection.classList.contains('body-content-big-board') : false;
	        _this.viewports = new _Viewports2.default();
	        _this.currentUrl = location.href;
	
	        if (trendingTitleEl != null) {
	            _this.collectionOneUtm.term = _TrackingUtils2.default.formatStringAsSlug(trendingTitleEl.innerHTML);
	        }
	        return _this;
	    }
	
	    _createClass(FsVideo, [{
	        key: 'initPlayer',
	        value: function initPlayer(playerId, playerData) {
	            //init player
	            var player = new FDM_Player(playerId);
	
	            // set player settings directly
	            player.autoplay = playerData.autoplay;
	            player.share_embed = playerData.share_embed;
	            player.endcard = playerData.endcard;
	            player.endcard_feed = playerData.endcard_feed;
	            player.endcard_countdown = playerData.endcard_countdown;
	            player.releaseURL = playerData.releaseURL;
	            player.tag = playerData.tag ? playerData.tag : '';
	            player.title = playerData.title ? playerData.title : '';
	            player.vid = playerData.vid ? playerData.vid : null;
	            player.url = playerData.url ? playerData.url : '';
	            player.endcard_autoadvance = playerData.endcard_autoadvance ? playerData.endcard_autoadvance : false;
	            player.siteSection = playerData.siteSection ? playerData.siteSection : '';
	            if (playerData.categoryName) player.categoryName = playerData.categoryName;
	            if (playerData.adpol) player.freewheel_keyvalue = encodeURIComponent('adpol=' + playerData.adpol);
	            if (playerData.wcEndcard) player.wcEndcard = playerData.wcEndcard;
	
	            return player;
	        }
	
	        /**
	         * gets player data from url
	         */
	
	    }, {
	        key: 'getPlayerDataFromUrl',
	        value: function getPlayerDataFromUrl() {
	            var urlQuery = location.search;
	
	            var videourl = (0, _fsPlayerUtils.getParam)(urlQuery, "videourl");
	            var autoplay = (0, _fsPlayerUtils.getParam)(urlQuery, "autoplay");
	            var share = (0, _fsPlayerUtils.getParam)(urlQuery, "share");
	            var endcard_feed = (0, _fsPlayerUtils.getParam)(urlQuery, "endcard_feed");
	            var siteSection = (0, _fsPlayerUtils.getParam)(urlQuery, "siteSection");
	            var category = (0, _fsPlayerUtils.getParam)(urlQuery, "category");
	            var endcard_autoadvance = (0, _fsPlayerUtils.getParam)(urlQuery, "endcard_autoadvance");
	            var url = (0, _fsPlayerUtils.getParam)(urlQuery, "url");
	            var isAmp = (0, _fsPlayerUtils.getParam)(urlQuery, "amp");
	            var host = location.protocol + '//' + location.hostname + '/';
	            var deepLink = "http://www.foxsports.com/" + category + '/video/';
	            var iframeurl = host + 'video-embed?videourl=' + videourl + '&share=' + share + '&siteSection=' + siteSection + '&autoplay=' + autoplay + '&category=' + category + '&endcard_autoadvance=' + endcard_autoadvance + (endcard_feed ? '&endcard_feed=' + endcard_feed : '');
	            var isWCEndacrd = (0, _fsPlayerUtils.getParam)(urlQuery, "wcEndcard") === 'true';
	            var vid = decodeURIComponent(url).split('/').pop();
	            var wcEndcard = false;
	            if (isWCEndacrd) {
	                wcEndcard = {
	                    homeTeamCountryImgSrc: decodeURIComponent((0, _fsPlayerUtils.getParam)(urlQuery, "homeTeam")),
	                    awayTeamCountryImgSrc: decodeURIComponent((0, _fsPlayerUtils.getParam)(urlQuery, "awayTeam")),
	                    fullCoverageUrl: "https://www.foxsports.com" + decodeURIComponent((0, _fsPlayerUtils.getParam)(urlQuery, "fcUrl"))
	                };
	            }
	
	            return {
	                releaseURL: decodeURIComponent(videourl),
	                autoplay: autoplay,
	                share: share,
	                endcard_feed: decodeURIComponent(endcard_feed),
	                isAmp: isAmp,
	                siteSection: siteSection,
	                category: category,
	                endcard_autoadvance: endcard_autoadvance,
	                url: url,
	                deeplink: deepLink,
	                iframeurl: iframeurl,
	                vid: vid,
	                wcEndcard: wcEndcard
	            };
	        }
	
	        /**
	         * initializes FS video embed player
	         * @param {*} data - player data
	         */
	
	    }, {
	        key: 'initializeFSPlayer',
	        value: function initializeFSPlayer(data) {
	
	            this.playerData = this.preparePlayerData(data);
	            this.elId = this.getPlayerElement(this.playerData).id;
	            this.el = document.getElementById(this.elId);
	            this.utmObj = {};
	            //check if player has its own utm params
	            if (typeof this.playerData.utm !== 'undefined') {
	                this.utmObj = _TrackingUtils2.default.getUtmObj(this.playerData.utm);
	            } else {
	                this.utmObj = _TrackingUtils2.default.getUtmObj(_TrackingUtils2.default.getUtmParams(this.playerData.pageName));
	            }
	            //init player
	            this.player = this.initPlayer(this.elId, this.playerData);
	
	            this.isPlaying = false;
	            this.isPaused = false;
	            this.isFullScreen = false;
	            //init an empty set that will keep track all the videos that have been played
	            this.playedVideos = new Set();
	            this.sendPageView = data.sendPageView;
	
	            // set player settings using functions
	            this.setPlayerShare();
	            this.setPlayerEvents();
	
	            document.addEventListener('visibilitychange', this.onVisibilityChange.bind(this));
	
	            //start pinning from Pinner.js. Dont enable on iphone
	            !this.isIphone() && this.startPinning();
	
	            this.saveToPlayerCollection();
	        }
	
	        /**
	         *  initializes FS video embed player
	         */
	
	    }, {
	        key: 'initializeFSEmbedPlayer',
	        value: function initializeFSEmbedPlayer() {
	            //init player
	            var playerData = this.getPlayerDataFromUrl();
	            this.player = this.initPlayer("player", playerData);
	            this.utmObj = _TrackingUtils2.default.getUtmObj({
	                'medium': playerData.isAmp ? "amp_video_player" : "embed_video_player",
	                'source': 'embed-video-page',
	                'content': playerData.category,
	                'term': ''
	            });
	
	            if (playerData.share) {
	                this.player.share = {
	                    deeplinkfunc: function deeplinkfunc(z, A) {
	                        return playerData.deeplink + z;
	                    },
	                    embed: true,
	                    iframeurl: playerData.iframeurl,
	                    emailscript: "",
	                    sharetargets: [{
	                        name: "Facebook",
	                        image: "data:image/png;base64,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",
	                        urlTemplate: "http://www.facebook.com/sharer.php?u=<%= url %>"
	                    }, {
	                        name: "Twitter",
	                        image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEcAAABHCAMAAABibqotAAAATlBMVEX///9Ny+dAvuFDweJJyOZEw+NCwOJMyudBv+JLyeZIxuVGxORHxeRDweNq0Orq+fyA1+3C7Pb2/P7U8vnf9fum4/KS3fBczOi06PROxeX5zaKxAAABnElEQVRYw+3UyW6DMBCA4aHBSSFkvC+8/4u2RYq8LwcOTZv/aFmfRowFTOf0Z53bOb2dF3OWc3o7ZznolACgji3PbOjMUbe5kuXwTOJxgtzMvthZpC0zSCHIzNZIoFPVYUBtkREQdahsrjoOQBWgSUGe/j6vOT/3KWaOLjETczpw1rBjXsHWuEXkDJUAavJ3UufI3aJTBsWoXWuOel6JRtIdJnfCR+JPXYmRnskdE15kN69niWVtOLuI7nJma/OINXfygXyUa1Oah7adWUK/vmOWaRCSTUcIrumQw1NnC1Mwmt7iYscNO6zp4LBjm842ui61pc49CsWYo+9JiUPMmIO5k2RGJlL3rkOQ9x2TOyRp3/sS3Ula5iD0M6TvkP7q6dZyxgdiZMTprp6ThjMO0X3UIajqjEDSdXyM08bH6Tu+u26sfNxB2WRy51Gq8qIFe9SCSxpBraCYwku10GFOOy5F/Zd8aTseauyb26rhHS/JioKXdnBNsvnXkWa/9vJOQDHNlQAAQZXTzCNNp9+/dj7P6e28mPNxTr/N+QKykG1J+VJKjAAAAABJRU5ErkJggg==",
	                        urlTemplate: "http://twitter.com/share?url=<%= url %>&text=<%= title %>"
	                    }, {
	                        name: "googleplus",
	                        image: "data:image/png;base64,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",
	                        urlTemplate: "https://plus.google.com/share?url=<%= url %>"
	                    }, {
	                        name: "reddit",
	                        image: "data:image/png;base64,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",
	                        urlTemplate: "http://reddit.com/submit?url=<%= url %>"
	                    }, {
	                        name: "stumbleupon",
	                        image: "data:image/png;base64,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",
	                        urlTemplate: "http://www.stumbleupon.com/submit?url=<%= url %>"
	                    }],
	                    omitSeries: true
	                };
	            }
	            this.setPlayerEvents();
	        }
	    }, {
	        key: 'isIphone',
	        value: function isIphone() {
	            return (/iPhone/i.test(navigator.userAgent)
	            );
	        }
	
	        //save instances of player to collection
	
	    }, {
	        key: 'saveToPlayerCollection',
	        value: function saveToPlayerCollection() {
	
	            window.fsPlayerCollection = window.fsPlayerCollection || [];
	            window.fsPlayerCollection.push(this);
	        }
	
	        /**
	         * @desc pause other players in the page triggered by setPlay method
	         */
	
	    }, {
	        key: 'pauseOtherPlayers',
	        value: function pauseOtherPlayers() {
	            var _this2 = this;
	
	            try {
	                //returns all players except the current player the user is interacting with
	                var players = window.fsPlayerCollection.filter(function (fsPlayer) {
	                    return fsPlayer.elId !== _this2.elId;
	                });
	            } catch (e) {
	                console.log("VIDEO: error - ", e);
	            }
	
	            if (players.length > 0) {
	                players.forEach(function (fsPlayer) {
	                    fsPlayer.isPinned && fsPlayer.unpin(fsPlayer.parentEl);
	                    fsPlayer.isPlaying = false;
	                    fsPlayer.player.pause();
	                });
	            }
	        }
	    }, {
	        key: 'pauseAllPlayers',
	        value: function pauseAllPlayers() {
	            var players = window.fdmPlayer;
	            try {
	                players.forEach(function (player, index) {
	                    if (index !== players.length - 1) {
	                        player.releaseUrl = '';
	                        player.releaseURL = '';
	                        player.setReleaseCall('');
	                        player.pause();
	                    }
	                });
	            } catch (e) {
	                console.log('something went wrong', e);
	            }
	        }
	    }, {
	        key: 'onVisibilityChange',
	        value: function onVisibilityChange() {
	            document.hidden && this.player.pause();
	        }
	
	        /**
	         * @desc event triggered on player OnMediaStart and OnMediaUnpause events
	         * @param isAd True or False for e.data.baseClip.isAd that is passed from player OnMediaStart and OnMediaUnpause events
	         * @returns {FsVideo}
	         */
	
	    }, {
	        key: 'setPlay',
	        value: function setPlay(isAd) {
	
	            this.isPlaying = true;
	            this.isPaused = false;
	            if (window.fsPlayerCollection) {
	                this.pauseOtherPlayers();
	            }
	
	            _TrackingUtils2.default.sendPlay(isAd, this.player, this.utmObj);
	
	            return this;
	        }
	    }, {
	        key: 'pause',
	        value: function pause() {
	            this.player.pause(true);
	        }
	
	        /**
	         * @desc event triggered on player OnMediaStart event
	         * @returns {FsVideo}
	         */
	
	    }, {
	        key: 'setPause',
	        value: function setPause(isAd) {
	
	            this.isPlaying = false;
	            this.isPaused = true;
	
	            _TrackingUtils2.default.sendPause(isAd, this.player, this.utmObj);
	
	            return this;
	        }
	
	        /*
	            get page type of where the video player is set/loaded
	        */
	
	    }, {
	        key: 'getPageType',
	        value: function getPageType(playerData) {
	            /*
	                first 3 conditions supercedes what is set on the video config's "pageName"
	                which, from testing, doesn't reflect the actual page type of where the video is set.
	            */
	            if (this.isSectionFront) return 'section-front'; // if page is section front
	            if (this.isMediaHub) return 'media-hub'; // if page is media hub
	            // if page isn't section front or media hub, but the url of the post passed on the video config is a story
	            if (playerData.url.indexOf('\/story\/') > -1) return 'story-page';
	
	            // everything else aside from the conditions above are assumed
	            var pageName = playerData.pageName.split(/\:/);
	
	            return pageName[pageName.length - 1].replace(/ /g, "-");
	        }
	
	        /**
	         * send page view to Parsely on video player. We only send the page view on first click on section front pages.
	         * We send page view only if the video ID is in the video player url that is available to us
	         */
	
	    }, {
	        key: 'sendParselyTracking',
	        value: function sendParselyTracking() {
	            //add player video id into the set if it is not in the set so that it is only tracked on the first click on that video
	            var vid = this.player.videoinfo.id ? this.player.videoinfo.id : this.player.vid;
	            if (_TrackingUtils2.default.isTrackable(vid, this.currentUrl) && !this.playedVideos.has(vid)) {
	                // update player url 
	                if (vid !== this.player.vid) {
	                    this.player.url = this.getVideoUrl(this.player.videoinfo.id);
	                    this.player.vid = vid;
	                }
	
	                if (typeof PARSELY !== 'undefined' && _typeof(PARSELY.beacon) === 'object' && typeof PARSELY.beacon.trackPageView === 'function') {
	                    // set up for UTM Campaign tracking - FSCOM-12271
	                    var metadata = _TrackingUtils2.default.getTrackingMeta(this.player);
	
	                    // failover for utm_content (start with defined utmObj, metadata, videoinfo, categoryName)
	                    this.utmObj.utm_content = this.utmObj.utm_content || metadata.section || this.player.videoinfo.primary || this.playerData.categoryName;
	
	                    var trackingObj = {
	                        url: _TrackingUtils2.default.addTrackingQuery(this.utmObj, this.player.url), // URL to be tracked
	                        urlref: location.href,
	                        js: 1 // flag indicating that this is a dynamic event, keep it "1"
	                    };
	                    // TEMP(FOR STG/PROD): bug found on homepage "fox-five" tracking, but can't recreate on DEV env
	                    // need reports of these two objects.
	                    window['utmProdTest'] = {
	                        'utmObj': this.utmObj,
	                        'trackingObj': trackingObj
	                    };
	                    PARSELY.beacon.trackPageView(trackingObj);
	                }
	
	                this.playedVideos.add(this.player.videoinfo.id);
	            }
	        }
	    }, {
	        key: 'setPlayerEvents',
	        value: function setPlayerEvents() {
	            var _this3 = this;
	
	            var player = this.player;
	
	            if (this.playerData) {
	                var playerData = this.playerData;
	            }
	            player.start = function () {
	                performance.mark("fs-videoplayer-startplayer");
	                return player.bind(), player;
	            };
	
	            if (this.playerData) {
	                if (typeof this.playerData.onMediaPause === 'function') {
	                    player.addEventListener('OnMediaPause', function (e) {
	                        performance.mark("fs-videoplayer-onmediapause");
	                        playerData.onMediaPause(null, e, player);
	                    });
	                }
	            }
	
	            //check is free wheel enabled
	            if (playerData && playerData.isFwEnabled == true) {
	                player = this.setSiteSection(player, playerData.siteSection);
	            }
	
	            /**
	             * @desc Fires when playback of the current clip is paused.
	             */
	            player.addEventListener('OnMediaPause', function (e) {
	
	                if (this.player.wcEndcard) {
	                    _FsVideoEventHandler2.default.dispatchEvent(_FsVideoEventHandler.fsEvents.videoPause, { e: e, player: this.player });
	                }
	
	                try {
	                    //passing video clip OnMediaPause to check if it is an ad when setting video pause
	                    this.setPause(e.data.clip.baseClip.isAd);
	                } catch (err) {
	                    console.log('Error OnMediaPause: ', err.message);
	                }
	
	                performance.mark("fs-videoplayer-onmediapause");
	                if (playerData) playerData["onMediaPause"] && typeof playerData.onMediaPause === 'function' && playerData.onMediaPause(null, e, player);
	            }.bind(this));
	
	            /**
	             * @desc Fires when the current clip resumes playback after having been paused.
	             */
	            player.addEventListener('OnMediaUnpause', function (e) {
	                try {
	                    //passing video clip OnMediaUnpause to check if it is an ad when setting video play
	                    this.setPlay(e.data.clip.baseClip.isAd);
	                } catch (err) {
	                    console.log('Error OnMediaUnpause: ', err.message);
	                }
	            }.bind(this));
	
	            /**
	             * @desc Fires when a clip starts playing. This includes individual chapter starts within a media item.
	             * The ClipInfo component listens for this event to update its content. This is the only event where video
	             * or ad metadata is dispatched to the player. Video metadata can be pulled out of the event data object.
	             */
	            player.addEventListener(_FsVideoEventHandler.fsEvents.videoStart, function (e) {
	                try {
	                    if (!e.data.baseClip.isAd && this.sendPageView) {
	                        _FsVideoEventHandler2.default.dispatchEvent(_FsVideoEventHandler.fsEvents.videoStart, { e: e, player: this.player });
	                        this.sendParselyTracking();
	                    }
	                    //passing video clip OnMediaStart to check if it is an ad when setting video play
	                    this.setPlay(e.data.baseClip.isAd);
	                } catch (err) {
	                    console.log('Error OnMediaStart: ', err.message);
	                }
	
	                if (playerData) playerData[_FsVideoEventHandler.fsEvents.videoStart] && typeof playerData.onMediaStart === 'function' && playerData.onMediaStart(null, e, player);
	                performance.mark("fs-videoplayer-onmediastart");
	            }.bind(this));
	
	            /**
	             * @desc Fries when clip ends
	             */
	            player.addEventListener(_FsVideoEventHandler.fsEvents.videoEnd, function (e) {
	                _FsVideoEventHandler2.default.dispatchEvent(_FsVideoEventHandler.fsEvents.videoEnd, { e: e, player: this.player });
	            }.bind(this));
	
	            /**
	             * @desc Fires during clip playing
	             */
	            player.addEventListener(_FsVideoEventHandler.fsEvents.videoProgress, function (e) {
	                if (player.wcEndcard) {
	                    _FsVideoEventHandler2.default.dispatchEvent(_FsVideoEventHandler.fsEvents.videoProgress, { e: e, player: this.player });
	                }
	            }.bind(this));
	
	            /**
	             * @desc Fires when the player begins to load a new clip.
	             */
	            player.addEventListener(_FsVideoEventHandler.fsEvents.videoLoading, function (e) {
	                performance.mark("fs-videoplayer-onmedialoadstart");
	            });
	
	            /**
	             * @desc Fires when the player loads
	             */
	            player.addEventListener(_FsVideoEventHandler.fsEvents.playerReady, function (e) {
	                if (_this3.player.elem === e.originator.controlId) {
	                    performance.mark("fs-videoplayer-onplayerloaded");
	                    _FsVideoEventHandler2.default.dispatchEvent(_FsVideoEventHandler.fsEvents.playerReady, { e: e, player: _this3.player, playerData: _this3.playerData });
	                    window.currentPlayer = player;
	                }
	            });
	
	            /**
	             * @desc Fires when the release url starts
	             */
	            player.addEventListener('OnReleaseStart', function (e) {
	                performance.mark("fs-videoplayer-onreleasestart");
	                this.isModalEnabled && this.pauseAllPlayers();
	            }.bind(this));
	
	            /**
	             * @desc Fires when user clicks on the play button
	             */
	            player.addEventListener('OnPlayButtonClicked', function (e) {
	                performance.mark("fs-videoplayer-onplaybuttonclicked");
	                if (this.isIphone()) {
	                    var playerId = '#' + e.originator.controlId;
	                    var vidTag = document.querySelector(playerId + ' video');
	                    if (!vidTag.hasAttribute('playsinline')) {
	                        vidTag.setAttribute('playsinline', '');
	                    }
	                }
	            }.bind(this));
	
	            /**
	             * @desc Fires when the release url starts
	             */
	            player.addEventListener(_FsVideoEventHandler.fsEvents.playerFullScreen, function (e) {
	                performance.mark("fs-videoplayer-onfullscreen");
	
	                //set if player is fullscreen
	                this.isFullScreen = e.data;
	            }.bind(this));
	
	            player.start();
	
	            this.player = player;
	            this.playerData = playerData;
	
	            return this;
	        }
	    }, {
	        key: 'setSiteSection',
	        value: function setSiteSection(player, siteSectionPath) {
	
	            //freewheel
	            if (typeof siteSectionPath !== '"undefined"') {
	                console.log('has siteSection');
	            } else {
	                siteSectionPath = '/nfl/test/default';
	            }
	
	            var fwSiteSection = siteSectionPath;
	            // condition if siteSection already sets 'www.'
	            if (fwSiteSection.indexOf('www.') > -1) {
	                fwSiteSection = fwSiteSection.replace('www.', '');
	            }
	
	            fwSiteSection = this.getAdViewport(window.innerWidth) + '.' + fwSiteSection;
	
	            //get adzone
	            var adZoneVal = this.getAdZoneParam();
	            //assign siteSection
	            player.siteSection = adZoneVal !== "" ? adZoneVal : fwSiteSection;
	
	            return player;
	        }
	    }, {
	        key: 'getAdZoneParam',
	        value: function getAdZoneParam() {
	
	            function getParameterByName(name) {
	                name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	                var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
	                    results = regex.exec(location.search);
	                return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	            }
	
	            var adzoneParam = getParameterByName('adzone');
	
	            if (adzoneParam !== "") return adzoneParam;else return '';
	        }
	
	        /*
	         desktop = 1024 pixels and up
	         tablet = 768 - 1023
	         handheld = 767 and below
	         Touch detection for 1023 and below would override the breakpoints
	         */
	
	    }, {
	        key: 'getAdViewport',
	        value: function getAdViewport(windowWidth) {
	
	            var isTouch = this.isTouchDevice();
	
	            var viewportName = 'www';
	
	            switch (true) {
	                case !isTouch || windowWidth > 1023:
	                    viewportName = "www";
	                    break;
	                case windowWidth > 767 && isTouch:
	                    viewportName = "mtab";
	                    break;
	                default:
	                    viewportName = "mweb";
	            }
	
	            return viewportName;
	        }
	    }, {
	        key: 'isTouchDevice',
	        value: function isTouchDevice() {
	            return 'ontouchstart' in window;
	        }
	    }, {
	        key: 'getVideoUrl',
	        value: function getVideoUrl(id) {
	            return this.getCleanedDomain() + '/' + this.playerData.categoryName + '/video/' + id;
	        }
	    }, {
	        key: 'setPlayerShare',
	        value: function setPlayerShare() {
	
	            if (window.innerWidth > 1024) {
	                // older implementations incorrectly return share as a boolean
	                if (_typeof(this.playerData.share) === 'object' && this.playerData.share) {
	
	                    this.player.share = this.playerData.share;
	                } else {
	
	                    this.player.share = {
	                        showembedfunc: function showembedfunc(mid, vi) {
	                            if (vi.primary == 'nfl' && vi.contentType == 'highlights' || _typeof(this.state.clip) === 'object' && typeof this.state.clip !== null && this.state.clip.baseClip.contentCustomData["non-EmbeddableHighlights"] == "true") {
	
	                                return false;
	                            } else {
	
	                                return true;
	                            }
	                        },
	                        emailscript: '',
	                        sharetargets: this.playerData.fdmsharetargetsArr
	                    };
	                }
	
	                this.player.share = {
	                    embed: true,
	                    iframeurl: this.playerData.iframeUrl
	                };
	
	                if (typeof this.playerData.share_deeplinkfunc === 'function') {
	
	                    this.player.share.deeplinkfunc = playerData.share_deeplinkfunc;
	                } else {
	
	                    this.player.share.deeplinkfunc = function (mediaId, title, guid) {
	                        return this.getVideoUrl(mediaId);
	                    }.bind(this);
	                }
	            }
	
	            return this;
	        }
	    }, {
	        key: 'getCleanedDomain',
	        value: function getCleanedDomain() {
	            var l = window.location;
	
	            return l.origin || l.protocol + '//' + l.hostname + (l.port ? ':' + l.port : '');
	        }
	    }, {
	        key: 'defaultOpts',
	        value: function defaultOpts() {
	            // disable autoplay for mobile
	            var autoplay = this.viewports.isMobile ? false : true;
	
	            return {
	                autoplay: autoplay,
	                share: false,
	                share_embed: true,
	                endcard: true,
	                endcard_feed: '',
	                endcard_countdown: true,
	                hideMeta: false,
	                isFwEnabled: false,
	                iu: '',
	                siteSection: '',
	                pageLocation: 'index',
	                pageName: 'fscom::videos:video page',
	                releaseUrl: '',
	                categoryName: '',
	                fdmsharetargetsArr: [{
	                    name: "Facebook",
	                    image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAACl0lEQVR42u3a3UsUURzGcf+vELuI8iK6iLrIzOidoheCUC+yF4KitEAJcq11UyplVzaKyo1dEBZXslwlpUAqS6LxQszNyG3dml9zYgiJ2pyZnT20fh94Ls7VwO8zMMM5p2LNtnbDqljNWc1bNe01LX5Ne8Y5e21UMBS9BQAAABgEAABQAACgAABAAQCAAgDAqurWY3fkxMVH0hJMSkf4qYSiaQn2jfxqoHdYWrtTcr59QJpa43L8wgPZ2RiRTQe7paq2AwCnXVt3XU63JSQx9FoyC1nxms1HbgGwkq7bFbTe6Gcy/8n70Jdny9HbAPyrDS0xmZv/In4EgAKt3B6QnofPxc8AUGD48dQr8TsA/KV9jyekFAHgD1W/i6UKAL+1em9IMp+zAOhqr88fXQAKdMOeTsl+zQOgq1dCg1LqALCsoy8+AKBzq+G7aQKgq4fP3S/KQFOj09IcTMq+k9Gfw1XflUKtrAkAoKq2jL1E7YweOnuP8wC3DfePewJQ+/wcyHjowPAb18OfnJrlRMxrh8amXQPcjKYB8Nqxl4ZrgDNXEwDoBKhv7gdAJ4D6hQUAAAAAAAAAAAAAAAAAAFjVADvqw5IceeuoXm5CjE/OOH6e6qUbyfIEKNbhit+51vMEAJ051RYHQGfUsSUAGrPxQBcAuqIugJXtX9D/ADD1/iMAOjOYfgeAzkRiEwDojLqHBIDGNF6OAaAzdQ0RAHRm/e5OAHRFbfyV9W7o/qa7MjO74KhLS99cD3Qus+joWeoGNecBnAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABj2Imc1b9UEwLea9oxz9tr4AS/jbaNehFRZAAAAAElFTkSuQmCC",
	                    urlTemplate: "http://www.facebook.com/sharer.php?u=<%= url %>"
	                }, {
	                    name: "Twitter",
	                    image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAIAAABt+uBvAAAFGUlEQVR42u2b+W8TVxDH80/WCQHSCEUtLagHoodKS6tWRRShNkUQ9aAIqVVb0fhITGISIElNnPtwE0hCMM1JYhKzh/e+O5IhVRPq2uv33m7ojN4PtiXvvv3svO/MvJ2te6mdw1Fm1CECBISAEBACQkAICAEhIBwICAEhIASEgBAQAkJAOBAQAkJACAgBVTUOJ/gLY3J6xVgv2pbjlYzTnJnH1i931TduCBUeJ/LiAWrq4OMLmmq5XlnL5s33b4tljvNWj5hZM5o7eHaAPuwvRijT+TQtgZt4lZnreslFrSG2+yAfDRSH1w3H9QaWDXZL7GCc5zWnfV6jR+eHacV1vWrt7pb1cgdfH+XAoWB6j4p26Xfb8d7sEdkBujQul078/ZRCg843k4rn1wqqs3dJ+ruX/gFNbZo75744LpOlc6q/6LgeQZvbthqiDKNYJMrtukWXp4n5UWOM25QcgnRynNXc+VSbjyT51lGZOqDjKWHvPBL3NSKafTWrEKQzuWlCHHytW2ibkCc2TMN2P/m9SB3QB33F585mfMOsNo7u9c0thZj7CLoLUECSdn759Z7KYonBTfi3OeVlB/D5BnR6oOhRs/5lg1Gi+N5tscw8QF8hZDTG/bhSdF6jRAdc6UCMlUi3JIX/nNCG5JwZlKo9MlwGDTp3Vo36KNtarMIEd3bLqmrFLQs2cTrX5vxHD/+A+pb0qrLbc0NSpIJ7SFChS3altvyjroYqqWo13Vac2IJ2ordcvr8qEvYguDGBbXcs8T4vBiJd9wP9/LDUktwt5OBrLw6gMsG+cgMty+bNGzn9xxkVShb4TBZQVWkh+f2g3oe6F24rv0lErRZ79gEyi1nSi4Ksvd0bBKALY/LgqlGK34fi/MxjM7SADsX5AACdzUil00NUTq8YP8+qoLshpAMCF8ym/cmborcfbH7bCgZQQ5TTLTf8gHoe6oE99hlZN8MP6OtROTBAXzyToTDb691CYICgsCJeFpC1gurUvr1ZU6LooxxjaamcHjAgGF0PwptJ11hkkAFUH6W1xVWjibrrb4eM/LN5qDYya0bYAHUuknnkS6Z5AUqzy9OKFprMCOZxLCWECFBpvHJd6M7pYcAEqz5c/UHHU8LRLqEpwTd38id6xb4l3XL2vTyTBNQ6KodHfabzJsFlQQYQ6LSgh0WA3r0lhg5QqZcnDHTSKwZBOiQBQdJxvxDw1qJiui1JIaSAYIBOP1GDFOdLpNuUyDdxQggLitHIukmcDpUuV/Aj9mttS3F2WqT2QZ806NGVrCLojFxJt9yTN0UaF0K3Txpi/8VxeeyRqZoUMwDX9c5mJHpXwaKRHBwK1h0EYBqA2iZkqpNnAQjoUNoSodSBzA7QwTj/04xKo3y1Ha91VGZwd2kBaurgr/6h8hoVnZYM92Ny5ShTQI0x7sygBNW8btMS5hxn1/6sgiKgV7uExtjfjw+PJPl3bonnh6Xf5rRs3qS6GeS4XmLhOe+qhAvQqf5iqW+KcfH+J2/X2MjCbolB2P52UimwKingRG0TSiTKsadTkwZBHvjdlLLzshEN25BsOMWBWDBoyIh0pJ37LC1l1gyDnCqbjje0Znx+RwrKa6hEscMJ/qsReWDZ8L30oOCEv385Ijcl+MC50M2DjqUEiGvtcxo4wuITC5Ap/yzH4Oum5CwULKg/rt1Tzw1JkG3jW8/4WjgCQkA4EBACQkAICAEhIASEgHAgIASEgBAQAkJACAgB/b/HXwPPdZ/z7BalAAAAAElFTkSuQmCC",
	                    urlTemplate: "http://twitter.com/share?url=<%= url %>"
	                }]
	            };
	        }
	    }, {
	        key: 'preparePlayerData',
	        value: function preparePlayerData(opts) {
	            var playerData = this.defaultOpts();
	
	            Object.keys(opts).map(function (key) {
	                playerData[key] = opts[key];
	            });
	
	            // iu (interactive unit) is similar to a page path
	            // ex., '/fscom/homepage/video', '/fscom/nfl/video'
	            if (typeof playerData.iu === 'string') {
	                playerData.releaseURL += '&iu=' + playerData.iu;
	                playerData.endcard_feed += '&params=iu=' + playerData.iu;
	            }
	
	            return playerData;
	        }
	    }, {
	        key: 'getPlayerElement',
	        value: function getPlayerElement(opts) {
	            return document.getElementById('Video' + opts.id);
	        }
	    }]);
	
	    return FsVideo;
	}(_Pinner3.default);
	
	window.FsVideo = FsVideo;
	
	exports.default = FsVideo;

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //extended by fsVideo.js
	//provides ability to pin or dock video on lower right
	
	var _Viewports = __webpack_require__(7);
	
	var _Viewports2 = _interopRequireDefault(_Viewports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Pinner = function () {
	    function Pinner() {
	        _classCallCheck(this, Pinner);
	
	        this.header = document.querySelector('#body-header-wrapper');
	        this.pinPos = this.header ? this.header.clientHeight : 45;
	        this.resizeEv = undefined;
	        this.pinCloseEl = undefined;
	        this.pinWrapper = document.querySelector('.fs-pin-wrapper');
	        this.isTopPinEnabled = true;
	        this.isTopPinEnabled = this.pinWrapper && this.isTopPinEnabled;
	        //I dont like multiple wrappers but NEO player is limited for doing video pinning
	        this.parentEl = undefined;
	        this.grandParentEl = undefined;
	        this.parentElWrapper = undefined;
	        this.elInfo = undefined;
	        this.bodyClassList = document.body.classList;
	        this.disableVideoPinning = document.body.classList.contains('disable-video-pinning');
	        this.isJWPlayer = document.body.classList.contains('jw-player');
	
	        //using rAF for better scrolling performance - https://www.html5rocks.com/en/tutorials/speed/animations/
	        this.latestKnownScrollY = 0;
	        this.ticking = false;
	        this.isPinned = false;
	        this.resetDelay = 400;
	        this.viewport = new _Viewports2.default();
	    }
	
	    _createClass(Pinner, [{
	        key: 'startPinning',
	        value: function startPinning() {
	            //enable pinning when attribute is available
	            if (!this.disableVideoPinning) {
	                this.el.hasAttribute("enable-pinning") && this.enablePinning();
	            }
	        }
	    }, {
	        key: 'enablePinning',
	        value: function enablePinning() {
	
	            this.parentEl = this.el.parentElement;
	            this.grandParentEl = this.parentEl.parentElement;
	            if (this.isTopPinEnabled) {
	                this.parentElWrapper = this.grandParentEl.parentElement;
	                this.grandParentEl = this.parentElWrapper.parentElement;
	                this.elInfo = this.grandParentEl.querySelector('.fs-video-details');
	            }
	
	            this.startScroll();
	        }
	
	        //using rAF for better scrolling performance - https://www.html5rocks.com/en/tutorials/speed/animations/
	
	    }, {
	        key: 'startScroll',
	        value: function startScroll() {
	            window.addEventListener("scroll", function (ev) {
	                this.requestTick();
	            }.bind(this));
	        }
	
	        //udpate method for rAf - see above
	
	    }, {
	        key: 'requestTick',
	        value: function requestTick() {
	            if (!this.ticking) {
	                requestAnimationFrame(this.onScrollUpdate.bind(this));
	            }
	            this.ticking = true;
	        }
	    }, {
	        key: 'onScrollUpdate',
	        value: function onScrollUpdate() {
	
	            //for rAF scroll optimization - https://www.html5rocks.com/en/tutorials/speed/animations/
	            this.ticking = false;
	            //determine scroll direction
	            var newScrollY = window.scrollY;
	            var scrollDir = newScrollY < this.latestKnownScrollY - 1 ? "up" : "down";
	            var isVisible = this.viewport.isElmInViewport(this.grandParentEl);
	
	            if (!isVisible && !this.isPinned && !this.isFullScreen) {
	                (this.isPlaying || this.isJWPlayer && !this.player.paused) && this.pin(this.parentEl);
	            } //logic to pin when scrolling down 
	            if (isVisible && this.isPinned || this.isPinned && this.isFullScreen) {
	                this.unpin(this.parentEl);
	            }
	
	            this.latestKnownScrollY = newScrollY;
	        }
	
	        //for pinned state reserving space
	
	    }, {
	        key: 'retainSize',
	        value: function retainSize(el) {
	
	            var rect = el.getBoundingClientRect();
	            var height = rect.height;
	            var width = rect.width;
	
	            el.style.cssText = 'height:' + height + 'px;' + 'width:' + width + 'px;';
	        }
	    }, {
	        key: 'clearRetainSize',
	        value: function clearRetainSize(el) {
	            el.style.cssText = '';
	        }
	    }, {
	        key: 'onPinClose',
	        value: function onPinClose() {
	            this.fngPlayer ? this.player.pause() : this.pause();
	            this.unpin(this.parentEl);
	        }
	    }, {
	        key: 'createCloseButton',
	        value: function createCloseButton() {
	
	            var closeEl = document.createElement('span');
	            closeEl.className = this.isTopPinEnabled ? "pin-top pin-close" : "pin-close";
	            closeEl.innerHTML = "&#x2715;";
	            closeEl.addEventListener("click", this.onPinClose.bind(this));
	
	            return closeEl;
	        }
	    }, {
	        key: 'addCloseButton',
	        value: function addCloseButton() {
	            this.pinCloseEl = this.pinCloseEl || this.createCloseButton();
	            this.isTopPinEnabled ? this.parentElWrapper.appendChild(this.pinCloseEl) : this.parentEl.appendChild(this.pinCloseEl);
	        }
	    }, {
	        key: 'removeCloseButton',
	        value: function removeCloseButton() {
	            this.isTopPinEnabled ? this.parentElWrapper.removeChild(this.pinCloseEl) : this.parentEl.removeChild(this.pinCloseEl);
	        }
	    }, {
	        key: 'pin',
	        value: function pin(el) {
	
	            this.retainSize(this.grandParentEl);
	
	            el.classList.remove('unpin-player');
	            el.classList.add('pin-player');
	            if (this.isTopPinEnabled) {
	                this.bodyClassList.add('player-pinned');
	                var wrapper = el.parentElement.parentElement;
	                wrapper.classList.add('pin-player');
	                wrapper.classList.add('fade-in');
	            }
	
	            //temporary remove later
	            this.hackGalleryParentZIndex(true);
	
	            this.resetSize();
	            this.addCloseButton();
	
	            this.isPinned = true;
	
	            return el;
	        }
	    }, {
	        key: 'unpin',
	        value: function unpin(el) {
	            var _this = this;
	
	            el.classList.remove('pin-player');
	            if (this.isTopPinEnabled) {
	                var wrapper = el.parentElement.parentElement;
	                wrapper.classList.remove('pin-player');
	                wrapper.classList.remove('fade-in');
	                wrapper.classList.add('fade-out');
	            } else {
	                el.classList.add('unpin-player');
	            }
	
	            //temporary remove later
	            this.hackGalleryParentZIndex(false);
	            //need to reset for safari issue of position fixed to relative;
	            setTimeout(function () {
	                if (_this.isTopPinEnabled) {
	                    !_this.isPinned && _this.bodyClassList.remove('player-pinned');
	                    el.parentElement.parentElement.classList.remove('fade-out');
	                } else {
	                    el.classList.remove('unpin-player');
	                }
	                !_this.isPinned && _this.removeCloseButton();
	            }, this.resetDelay);
	
	            this.resetSize();
	
	            this.isPinned = false;
	
	            return el;
	        }
	
	        //very temporary hack for gallery fix
	
	    }, {
	        key: 'hackGalleryParentZIndex',
	        value: function hackGalleryParentZIndex(isPinned) {
	
	            var greatGrandParentEl = this.grandParentEl.parentElement;
	            var attrName = 'gallery-image-wrap-id';
	
	            if (greatGrandParentEl.hasAttribute(attrName)) {
	                var imgWrapId = greatGrandParentEl.getAttribute(attrName);
	                var galleryWrapEl = document.getElementById('gallery-image-wrap-' + imgWrapId);
	                //set zindex if pinned
	                isPinned ? galleryWrapEl.setAttribute('style', 'z-index:4') : galleryWrapEl.removeAttribute('style');
	            }
	        }
	
	        //NEO recommended dispatchEvent new Event to trigger resize of player
	
	    }, {
	        key: 'resetSize',
	        value: function resetSize(callback) {
	            var _this2 = this;
	
	            this.resizeEv = this.resizeEv ? this.resizeEv : new Event('resize');
	            var resizeDelay = this.resetDelay;
	
	            setTimeout(function () {
	                //from NEO, this resets the player viewport
	                window.dispatchEvent(_this2.resizeEv);
	                typeof callback === 'function' && callback();
	            }, resizeDelay);
	        }
	    }]);
	
	    return Pinner;
	}();
	
	exports.default = Pinner;

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TrackingUtils = function () {
	    function TrackingUtils() {
	        _classCallCheck(this, TrackingUtils);
	
	        this.isLogEnabled = false;
	        this.isBB = this.bodySection ? this.bodySection.classList.contains('body-content-big-board') : false;
	        this.checkLogEnabled();
	    }
	
	    _createClass(TrackingUtils, [{
	        key: 'log',
	        value: function log(message) {
	            this.isLogEnabled && console.log(message);
	        }
	    }, {
	        key: 'checkLogEnabled',
	        value: function checkLogEnabled() {
	            this.isLogEnabled = location.href.indexOf('trackinglog=true') > -1 ? true : false;
	        }
	
	        /**
	         * set tracking for link element
	         * @param {*} links
	         * @param {*} service
	         * @param {*} trackingObj
	         *     Example:
	         *        TrackingUtils.setLinkTracking(document.querySelectorAll('.more-video > a.fs-more-btn'),'parsely',{
	         *            'utm_campaign'  : 'more_videos',
	         *            'utm_medium'    : 'fscom',
	         *            'utm_content'   : 'morelink'
	         *        });
	         */
	
	    }, {
	        key: 'setLinkTracking',
	        value: function setLinkTracking(links, service, trackingObj) {
	            var _this = this;
	
	            if (!links || !links.length || !service) return;
	
	            if (links.constructor.name === 'NodeList') {
	                links = [].concat(_toConsumableArray(links));
	            }
	
	            for (var i = 0, lLen = links.length; i < lLen; i++) {
	                var link = links[i];
	                if (link.hasAttribute('data-link-tracked-by')) break;
	
	                if ('parsely' === service) {
	                    link.addEventListener('click', function (e) {
	                        _this.ParselyTrackLink(e, trackingObj);
	                    });
	                }
	                link.setAttribute('data-link-tracked-by', service);
	            }
	        }
	
	        /**
	         * add to target's event.addEventListener
	         * @param {*} ev
	        * @param trackingObj
	         */
	
	    }, {
	        key: 'ParselyTrackLink',
	        value: function ParselyTrackLink(ev, trackingObj) {
	            if (ev.preventDefault) ev.preventDefault();
	
	            var target = ev.currentTarget || ev.target;
	            var url = target.getAttribute('href');
	            var urlToTrack = target.getAttribute('data-url-to-track');
	
	            if (typeof PARSELY !== "undefined" && _typeof(PARSELY.beacon) === "object" && typeof PARSELY.beacon.trackPageView === 'function') {
	                var parselyObj = {
	                    'url': this.addTrackingQuery(trackingObj, urlToTrack || url),
	                    'js': 1
	                };
	
	                PARSELY.beacon.trackPageView(parselyObj);
	            }
	
	            window.open(url, target.getAttribute('target') || '_self');
	        }
	
	        /**
	         * constructing url param by using JS object (wrapping function)
	         * @param {*} trackingObj
	         * @param {*} url
	         */
	
	    }, {
	        key: 'addTrackingQuery',
	        value: function addTrackingQuery(trackingObj, url) {
	            for (var i in trackingObj) {
	                var val = trackingObj[i];
	                if (val) {
	                    url = this.updateQueryStringParam(url, i, val);
	                }
	            }
	            return url;
	        }
	
	        /**
	         * constructing url param by using JS object (actual logic)
	         * based on "https://stackoverflow.com/a/6021027"
	         * @param {*} uri
	         * @param {*} key
	         * @param {*} value
	         */
	
	    }, {
	        key: 'updateQueryStringParam',
	        value: function updateQueryStringParam(uri, key, value) {
	            var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
	            if (uri.match(re)) {
	                return uri.replace(re, '$1' + key + "=" + value + '$2');
	            } else {
	                var hash = '';
	                if (uri.indexOf('#') !== -1) {
	                    hash = uri.replace(/.*#/, '#');
	                    uri = uri.replace(/#.*/, '');
	                }
	                var separator = uri.indexOf('?') !== -1 ? "&" : "?";
	                return uri + separator + key + "=" + value + hash;
	            }
	        }
	
	        /**
	         * Replace empty spaces with dashes
	         * @param {string} str
	         */
	
	    }, {
	        key: 'replaceSpacesWithDash',
	        value: function replaceSpacesWithDash(str) {
	            return str.replace(/ /g, "-");
	        }
	
	        /**
	         * get vide title, image and section from video player info
	         * @returns Object {{title: string, image_url: string}}
	         */
	
	    }, {
	        key: 'getTrackingMeta',
	        value: function getTrackingMeta(player) {
	
	            var title = '';
	            var thumbnail = '';
	            var section = '';
	            var id = '';
	            var url = '';
	
	            if (typeof player.videoinfo.thumbnail !== "undefined") {
	                thumbnail = player.videoinfo.thumbnail;
	            }
	
	            if (typeof player.videoinfo.title !== "undefined") {
	                title = player.videoinfo.title;
	            }
	
	            if (typeof player.videoinfo.primary !== "undefined") {
	                section = player.videoinfo.primary;
	            }
	
	            if (typeof player.videoinfo.id !== "undefined") {
	                id = player.videoinfo.id;
	            }
	
	            if (typeof player.url !== "undefined") {
	                url = player.url;
	            }
	
	            return {
	                title: title,
	                image_url: thumbnail,
	                section: section,
	                id: id,
	                url: url
	            };
	        }
	
	        /**
	         * @desc event triggered on player OnMediaStart and OnMediaUnpause events
	         * @param isAd True or False for e.data.baseClip.isAd that is passed from player OnMediaStart and OnMediaUnpause events
	         * @returns {FsVideo}
	         */
	
	    }, {
	        key: 'sendPlay',
	        value: function sendPlay(isAd, player, utmObj) {
	            //only send parsely tracking on video play when the video clip is not an ad
	            if (!isAd) {
	                var metadata = this.getTrackingMeta(player);
	                this.sendTracking("play", metadata, utmObj);
	            }
	
	            return this;
	        }
	
	        /**
	         * @desc event triggered on player OnMediaStart event
	         * @returns {FsVideo}
	         */
	
	    }, {
	        key: 'sendPause',
	        value: function sendPause(isAd, player, utmObj) {
	
	            this.isPlaying = false;
	            this.isPaused = true;
	
	            //only send parsely tracking on video pause when the video clip is not an ad
	            if (!isAd) {
	                var metadata = this.getTrackingMeta(player);
	                this.sendTracking("pause", metadata, utmObj);
	            }
	
	            return this;
	        }
	
	        /**
	         * @desc Send parsely tracking when video is played or paused
	         * parsely doc: https://www.parsely.com/help/integration/video/
	         * @param type
	         * @param metadata
	         * @param utmObj
	         */
	
	    }, {
	        key: 'sendTracking',
	        value: function sendTracking(type, metadata, utmObj) {
	
	            //if only send parsely tracking when there is video ID and PARSELY is available
	            var isParsely = typeof PARSELY !== 'undefined' && _typeof(PARSELY.video) === 'object';
	            if (typeof metadata !== "undefined" && metadata.id !== "undefined" && isParsely) {
	
	                /**
	                 * we only include title, image_url and section for tracking
	                 * We don't have pub_date_tmsp, tags and authors from the video player info.
	                 * We can get them, but it will require additional server call for the videos,
	                 * so we skip including them at this moment
	                 */
	                var urlOverride = metadata.url !== '' ? metadata.url : location.origin + location.pathname;
	                //let metadata = this.getTrackingMeta();
	
	                metadata.section = utmObj.utm_content || utmObj.utm_section;
	                urlOverride = this.addTrackingQuery(utmObj, urlOverride);
	
	                //the following log info for debugging purpose on the console. We will remove it when we release it to prod
	                this.log('\n                    VIDEO TRACKING: sending parsely data\n                    type: ' + type + '\n                    title: ' + metadata.title + '\n                    thumbnail: ' + metadata.image_url + '\n                    vid: ' + metadata.id + '\n                    urlOverride: ' + urlOverride + '\n                    config: ' + JSON.stringify(metadata) + ' \n            ');
	
	                try {
	                    if (type === 'play') {
	                        PARSELY.video.trackPlay(metadata.id, metadata, urlOverride);
	                    } else if (type === 'pause') {
	                        PARSELY.video.trackPause(metadata.id, metadata, urlOverride);
	                    } else {
	                        console.log("Tracking Type Not Supported", type);
	                    }
	                } catch (err) {
	                    console.log("Error sending tracking info: ", err);
	                }
	            }
	        }
	
	        /**
	         * @desc replace string to a slug-like format
	         * @returns String
	         * i.e., "This Is A Slug!" = "this-is-a-slug"
	         */
	
	    }, {
	        key: 'formatStringAsSlug',
	        value: function formatStringAsSlug(str) {
	            return str.replace(/[^A-Z0-9]+/ig, "-").toLowerCase();
	        }
	
	        /**
	         * It is trackable for page view if it is on section front page and the video config include video id in url
	         * @param string videoId 
	         * @param string currentUrl
	         * @returns {boolean} 
	         */
	
	    }, {
	        key: 'isTrackable',
	        value: function isTrackable(videoId, currentUrl) {
	            //return true if id from url match the current url id does not match
	            return '' !== videoId && currentUrl.substr(currentUrl.lastIndexOf('/') + 1) !== videoId;
	        }
	
	        /**
	         * format object for UTM tracking use
	         * @param {obj} unformatted utm object
	         */
	
	    }, {
	        key: 'getUtmObj',
	        value: function getUtmObj(obj) {
	            var result = {};
	            // loop through object and reformatting property names for UTM tracking
	            for (var item in obj) {
	                switch (item) {
	                    case "campaign":
	                    case "section":
	                    case "source":
	                    case "medium":
	                    case "content":
	                    case "term":
	                        result["utm_" + item] = obj[item];
	                        break;
	                    default:
	                        break;
	                }
	            }
	            // failover check for "utm_campaign" and "utm_medium"
	            result["utm_campaign"] = result["utm_campaign"] || "video_playback_location";
	            if (typeof result["utm_medium"] === 'undefined') {
	                if (typeof this.isBB !== 'undefined') {
	                    this.isSectionFront = document.body.classList.contains('single-fox_sectionfront');
	                    this.isMediaHub = document.body.classList.contains('single-fox_media_hub');
	                    this.isBB = this.bodySection ? this.bodySection.classList.contains('body-content-big-board') : false;
	                }
	                result["utm_medium"] = this.isBB ? 'bb_video_player' : 'video_player';
	            }
	            return result;
	        }
	
	        /**
	         * Gets utm params based on the Page Name property from the video config object
	         * Format for the page name params is i.e fscom:nfl:section-front:featured-content
	         * [0] = site
	         * [1] = section/category - (utm_content)
	         * [2] = page type - (utm_source)
	         * [3] = term - (utm_term)
	         * @param {string} pageName
	         */
	
	    }, {
	        key: 'getUtmParams',
	        value: function getUtmParams(pageName) {
	            pageName.split(':');
	            return {
	                site: pageName[0] || '',
	                section: pageName[1] || '',
	                source: pageName[2] || '',
	                term: pageName[3] || ''
	            };
	        }
	        /**
	         * get embed utm params
	         * @param {*} isAmp 
	         * @param {*} category 
	         */
	
	    }, {
	        key: 'getEmbedUtmParams',
	        value: function getEmbedUtmParams(isAmp, category) {
	            return this.getUtmObj({
	                'medium': isAmp ? "amp_video_player" : "embed_video_player",
	                'source': 'embed-video-page',
	                'content': category,
	                'term': ''
	            });
	        }
	    }]);
	
	    return TrackingUtils;
	}();
	
	exports.default = new TrackingUtils();

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fsEvents = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _SegmentAnalytics = __webpack_require__(10);
	
	var _SegmentAnalytics2 = _interopRequireDefault(_SegmentAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var fsEvents = exports.fsEvents = {
	    videoLoad: 'OnLoadReleaseUrl',
	    videoBuffer: 'OnMediaBuffer',
	    videoEnd: 'OnMediaComplete',
	    videoChapterEnd: 'OnMediaEnd',
	    videoError: 'OnMediaError',
	    videoLoading: 'OnMediaLoadStart',
	    videoReady: 'OnLoadRelease',
	    videoPause: 'OnMediaPause',
	    videoPlay: 'OnMediaPlay',
	    videoProgress: 'OnMediaPlaying',
	    videoSeek: 'OnMediaSeek',
	    videoStart: 'OnMediaStart',
	    videoResume: 'OnMediaUnpause',
	    videoMute: 'OnMute',
	    playerReady: 'OnPlayerLoaded',
	    playerOverlayUp: 'OnShowPlayOverlay',
	    playbackStart: 'OnPlaybackStart',
	    playbackComplete: 'OnPlaybackComplete',
	    contentStart: 'OnContentStart',
	    contentComplete: 'OnContentComplete',
	    contentPlaying: 'OnContentPlaying'
	};
	
	var FsVideoEventHandler = function () {
	    function FsVideoEventHandler() {
	        _classCallCheck(this, FsVideoEventHandler);
	
	        this.events = {};
	    }
	
	    _createClass(FsVideoEventHandler, [{
	        key: 'dispatchEvent',
	        value: function dispatchEvent(eventName, data) {
	            if (!this.events.hasOwnProperty(eventName)) return;
	            _SegmentAnalytics2.default.trackVideoEvent(eventName, data);
	            this.events[eventName].callbacks.forEach(function (cb) {
	                cb(data);
	            });
	        }
	    }, {
	        key: 'addEventListener',
	        value: function addEventListener(eventName, callback) {
	            if (!this.events.hasOwnProperty(eventName)) {
	                this.events[eventName] = {
	                    callbacks: []
	                };
	            }
	            this.events[eventName].callbacks.push(callback);
	        }
	    }, {
	        key: 'removeEventListener',
	        value: function removeEventListener(eventName, callback) {
	            if (this.events.hasOwnProperty(eventName)) {
	                var index = this.events[eventName].indexOf(callback);
	
	                if (index > -1) {
	                    this.events[eventName].splice(index, 1);
	                }
	            }
	        }
	    }, {
	        key: 'onVideoStart',
	        value: function onVideoStart(callback) {
	            this.addEventListener(fsEvents.videoStart, callback);
	        }
	    }, {
	        key: 'onVideoPause',
	        value: function onVideoPause(callback) {
	            this.addEventListener(fsEvents.videoPause, callback);
	        }
	    }, {
	        key: 'onVideoEnd',
	        value: function onVideoEnd(callback) {
	            this.addEventListener(fsEvents.videoEnd, callback);
	        }
	    }, {
	        key: 'onPlayerLoaded',
	        value: function onPlayerLoaded(callback) {
	            this.addEventListener(fsEvents.playerReady, callback);
	        }
	    }, {
	        key: 'onVideoProgress',
	        value: function onVideoProgress(callback) {
	            this.addEventListener(fsEvents.videoProgress, callback);
	        }
	
	        //segment analytics related events
	
	    }, {
	        key: 'onPlaybackStart',
	        value: function onPlaybackStart(callback) {
	            this.addEventListener(fsEvents.playbackStart, callback);
	        }
	    }, {
	        key: 'onPlaybackComplete',
	        value: function onPlaybackComplete(callback) {
	            this.addEventListener(fsEvents.playbackComplete, callback);
	        }
	    }, {
	        key: 'onContentStart',
	        value: function onContentStart(callback) {
	            this.addEventListener(fsEvents.contentStart, callback);
	        }
	    }, {
	        key: 'onContentComplete',
	        value: function onContentComplete(callback) {
	            this.addEventListener(fsEvents.contentComplete, callback);
	        }
	    }, {
	        key: 'onContentPlaying',
	        value: function onContentPlaying(callback) {
	            this.addEventListener(fsEvents.contentPlaying, callback);
	        }
	    }]);
	
	    return FsVideoEventHandler;
	}();
	
	var fsVideoEventHandler = new FsVideoEventHandler();
	window.FsVideoEventHandler = fsVideoEventHandler;
	exports.default = fsVideoEventHandler;

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getParam = getParam;
	exports.reformatReleaseUrl = reformatReleaseUrl;
	exports.convertTimeToSeconds = convertTimeToSeconds;
	function getParam(str, key) {
	    var regexS = "[\\?&]" + key + "=([^&#]*)";
	    var regex = new RegExp(regexS);
	    var results = regex.exec(str);
	    if (results == null) {
	        return "";
	    } else {
	        return results[1];
	    }
	}
	
	/**
	 * reformats the release url to a jw player supported release url
	 */
	function reformatReleaseUrl(releaseUrl) {
	    //constructing new release url format
	    var releaseId = releaseUrl.match(/BKQ29B\/(.*?)\?/)[1];
	    return releaseUrl = "https://link.theplatform.com/s/BKQ29B/" + releaseId + "?formats=m3u";
	}
	
	/**
	 * get duration in seconds. hours may need to be supported later on 
	 * @param string duration - expects something like "0:50"
	 * @return int - video duration
	 */
	function convertTimeToSeconds(time) {
	
	    return time ? time.split(':').reverse().map(function (i, idx) {
	        return +i * Math.pow(60, idx);
	    }).reduce(function (acc, curr) {
	        return acc + curr;
	    }, 0) : 0;
	}

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FsVideoEventHandler = __webpack_require__(35);
	
	var _FsVideoEventHandler2 = _interopRequireDefault(_FsVideoEventHandler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FsVideoWcEndcard = function () {
		function FsVideoWcEndcard() {
			_classCallCheck(this, FsVideoWcEndcard);
		}
	
		_createClass(FsVideoWcEndcard, [{
			key: 'initEndcards',
			value: function initEndcards() {
				var _this = this;
	
				_FsVideoEventHandler2.default.onVideoEnd(function (data) {
					return _this.render(data);
				});
				_FsVideoEventHandler2.default.onVideoPause(function (data) {
					return _this.render(data);
				});
				_FsVideoEventHandler2.default.onVideoProgress(function (data) {
					return _this.pauseIfNeeded(data);
				});
				_FsVideoEventHandler2.default.addEventListener('onForcePlay', function (data) {
					return _this.play(data);
				});
			}
		}, {
			key: 'pauseIfNeeded',
			value: function pauseIfNeeded(data) {
				if (!data || !data.player || !data.player.wcEndcard) return;
				if (data.player.vid === data.player.videoinfo.id) return;
	
				var endcardElem = document.getElementById(data.player.elem + '_wc-endcard');
				if (!endcardElem) return;
	
				data.player.pause();
			}
		}, {
			key: 'play',
			value: function play(data) {
				if (!data || !data.player || !data.player.wcEndcard) return;
				if (data.player.vid === data.player.videoinfo.id) return;
	
				data.player.play();
			}
		}, {
			key: 'render',
			value: function render(data) {
				if (!data || !data.player || !data.player.wcEndcard) return;
	
				if (data.player.vid !== data.player.videoinfo.id) return;
	
				// Check if it is match center page
				if (document.body.classList.contains('single-fox_big_board') && window.location.href.indexOf('soccer') > -1) return;
	
				var playerElem = document.getElementById(data.player.elem);
	
				if (!playerElem) return;
	
				var wcEndcard = data.player.wcEndcard;
	
				var endcardLayoutId = data.player.elem + '_wc-endcard';
				var endcardLayoutCloseId = endcardLayoutId + '_close';
				var endcardFullCavId = endcardLayoutId + '_fc';
	
				var isSmallContainer = playerElem.clientHeight < 300;
	
				var fullCoverageUrl = wcEndcard.fullCoverageUrl + '?utm_campaign=wc_promo&utm_source=wc_endcard';
				var isEmbed = playerElem.baseURI.indexOf('video-embed') !== -1;
				var target = isEmbed ? '_blank' : '_self';
	
				var endcardLayout = ['<div id="' + endcardLayoutId + '" class="wc-endcard_container" style="z-index: 1001; font-family: Antenna, Helvetica Neue, Arial, sans-serif;">', '<div class="wc-endcard_card" ' + (isSmallContainer ? 'style="padding: 20px;"' : '') + '>', '<div class="wc-endcard_description">', 'More highlights, full replay and stats available for this match', '</div>', '<a href="' + fullCoverageUrl + '" id="' + endcardFullCavId + '" class="wc-endcard_full-coverage" target="' + target + '">', 'See Full Coverage', '</a>', '<div class="wc-endcard_close-btn">', '<span id="' + endcardLayoutCloseId + '" style="">close</span>', '</div>', '</div>', '</div>'];
	
				if (!isSmallContainer) {
					var flags = ['<div class="wc-endcard_flags">', '<div class="wc-endcard_flags_flag">', '<img src="' + wcEndcard.homeTeamCountryImgSrc + '">', '</div>', '<div class="wc-endcard_flags_vc">vs</div>', '<div class="wc-endcard_flags_flag">', '<img src="' + wcEndcard.awayTeamCountryImgSrc + '">', '</div>', '</div>'].join('');
					endcardLayout.splice(2, 0, flags);
				}
	
				endcardLayout = endcardLayout.join('');
	
				playerElem.insertAdjacentHTML('afterend', endcardLayout);
	
				var endcardElem = document.getElementById(endcardLayoutId);
				var endcardCloseElem = document.getElementById(endcardLayoutCloseId);
	
				var endcardFullCavElem = document.getElementById(endcardFullCavId);
	
				var seconds = 0;
				var timeInterval = setInterval(function () {
					if (seconds === 9) {
						endcardCloseClick();
						return;
					}
	
					seconds++;
				}, 1000);
	
				var endacardFullCavClick = function endacardFullCavClick() {
					return window.open(fullCoverageUrl, target);
				};
	
				if (!isEmbed) {
					endcardFullCavElem.addEventListener('click', endacardFullCavClick);
				}
	
				var endcardCloseClick = function endcardCloseClick(e) {
					endcardCloseElem.removeEventListener('click', endcardCloseClick);
					!isEmbed && endcardFullCavElem.removeEventListener('click', endacardFullCavClick);
					clearInterval(timeInterval);
					endcardElem.remove();
					_FsVideoEventHandler2.default.dispatchEvent('onForcePlay', { player: data.player });
				};
	
				endcardCloseElem.addEventListener('click', endcardCloseClick);
			}
		}]);
	
		return FsVideoWcEndcard;
	}();
	
	exports.default = new FsVideoWcEndcard();

/***/ })

/******/ });


// WEBPACK FOOTER //
// assets/dist/js/fs-video.min.js